webpackJsonp([33019919093843],{

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var visit = __webpack_require__(322);
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var hastCssPropertyMap = {
	  align: 'text-align',
	  valign: 'vertical-align',
	  height: 'height',
	  width: 'width'
	};
	
	module.exports = function tableCellStyle(node) {
	  visit(node, 'element', visitor);
	  return node;
	};
	
	function visitor(node) {
	  if (node.tagName !== 'tr' && node.tagName !== 'td' && node.tagName !== 'th') {
	    return;
	  }
	
	  var hastName;
	  var cssName;
	  for (hastName in hastCssPropertyMap) {
	    if (
	      !hasOwnProperty.call(hastCssPropertyMap, hastName) ||
	      node.properties[hastName] === undefined
	    ) {
	      continue;
	    }
	    cssName = hastCssPropertyMap[hastName];
	    appendStyle(node, cssName, node.properties[hastName]);
	    delete node.properties[hastName];
	  }
	}
	
	function appendStyle(node, property, value) {
	  var prevStyle = (node.properties.style || '').trim();
	  if (prevStyle && !/;\s*/.test(prevStyle)) {
	    prevStyle += ';';
	  }
	  if (prevStyle) {
	    prevStyle += ' ';
	  }
	  var nextStyle = prevStyle + property + ': ' + value + ';';
	  node.properties.style = nextStyle;
	}


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var objectAssign = __webpack_require__(24);
	
	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:
	
	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	
	  var x = a.length;
	  var y = b.length;
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }
	
	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}
	
	// based on node assert, original notice:
	// NB: The URL to the CommonJS spec is kept just for tradition.
	//     node-assert has evolved a lot since then, both in API and behavior.
	
	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var util = __webpack_require__(1121);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.
	
	var assert = module.exports = ok;
	
	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })
	
	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;
	
	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }
	
	      this.stack = out;
	    }
	  }
	};
	
	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);
	
	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}
	
	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.
	
	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.
	
	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}
	
	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;
	
	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.
	
	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;
	
	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);
	
	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};
	
	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);
	
	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};
	
	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);
	
	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};
	
	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};
	
	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;
	
	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;
	
	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;
	
	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;
	
	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};
	
	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }
	
	    memos.actual.push(actual);
	    memos.expected.push(expected);
	
	    return objEquiv(actual, expected, strict, memos);
	  }
	}
	
	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}
	
	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}
	
	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);
	
	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};
	
	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}
	
	
	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);
	
	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};
	
	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
	
	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};
	
	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }
	
	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }
	
	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }
	
	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }
	
	  return expected.call({}, actual) === true;
	}
	
	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}
	
	function _throws(shouldThrow, block, expected, message) {
	  var actual;
	
	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }
	
	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }
	
	  actual = _tryBlock(block);
	
	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');
	
	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }
	
	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;
	
	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }
	
	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}
	
	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);
	
	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};
	
	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};
	
	assert.ifError = function(err) { if (err) throw err; };
	
	// Expose a strict only variant of assert
	function strict(value, message) {
	  if (!value) fail(value, true, message, '==', strict);
	}
	assert.strict = objectAssign(strict, assert, {
	  equal: assert.strictEqual,
	  deepEqual: assert.deepStrictEqual,
	  notEqual: assert.notStrictEqual,
	  notDeepEqual: assert.notDeepStrictEqual
	});
	assert.strict.strict = assert.strict;
	
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 1120:
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),

/***/ 1121:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","PUBLIC_DIR":"/home/circleci/project/public","GATSBY_ENVIRONMENT":"production","GATSBY_BUILD_DATE":"Wed Feb  5 12:12:46 UTC 2025","GATSBY_BUILD_COMMIT":"e6a8d204d6b8ad6474d40bd885c05813f4e9f92a"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1120);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(1906);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(172)))

/***/ }),

/***/ 241:
/***/ (function(module, exports) {

	'use strict'
	
	exports.parse = parse
	exports.stringify = stringify
	
	var comma = ','
	var space = ' '
	var empty = ''
	
	// Parse comma-separated tokens to an array.
	function parse(value) {
	  var values = []
	  var input = String(value || empty)
	  var index = input.indexOf(comma)
	  var lastIndex = 0
	  var end = false
	  var val
	
	  while (!end) {
	    if (index === -1) {
	      index = input.length
	      end = true
	    }
	
	    val = input.slice(lastIndex, index).trim()
	
	    if (val || !end) {
	      values.push(val)
	    }
	
	    lastIndex = index + 1
	    index = input.indexOf(comma, lastIndex)
	  }
	
	  return values
	}
	
	// Compile an array to comma-separated tokens.
	// `options.padLeft` (default: `true`) pads a space left of each token, and
	// `options.padRight` (default: `false`) pads a space to the right of each token.
	function stringify(values, options) {
	  var settings = options || {}
	  var left = settings.padLeft === false ? empty : space
	  var right = settings.padRight ? space : empty
	
	  // Ensure the last empty entry is seen.
	  if (values[values.length - 1] === empty) {
	    values = values.concat(empty)
	  }
	
	  return values.join(right + comma + left).trim()
	}


/***/ }),

/***/ 1408:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(1409);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_DIR":"/home/circleci/project/public","GATSBY_ENVIRONMENT":"production","GATSBY_BUILD_DATE":"Wed Feb  5 12:12:46 UTC 2025","GATSBY_BUILD_COMMIT":"e6a8d204d6b8ad6474d40bd885c05813f4e9f92a"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(172)))

/***/ }),

/***/ 1409:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(2249);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(261);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(262);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 1906:
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	// http://www.w3.org/TR/CSS21/grammar.html
	// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
	var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
	
	var NEWLINE_REGEX = /\n/g;
	var WHITESPACE_REGEX = /^\s*/;
	
	// declaration
	var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
	var COLON_REGEX = /^:\s*/;
	var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
	var SEMICOLON_REGEX = /^[;\s]*/;
	
	// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
	var TRIM_REGEX = /^\s+|\s+$/g;
	
	// strings
	var NEWLINE = '\n';
	var FORWARD_SLASH = '/';
	var ASTERISK = '*';
	var EMPTY_STRING = '';
	
	// types
	var TYPE_COMMENT = 'comment';
	var TYPE_DECLARATION = 'declaration';
	
	/**
	 * @param {String} style
	 * @param {Object} [options]
	 * @return {Object[]}
	 * @throws {TypeError}
	 * @throws {Error}
	 */
	module.exports = function(style, options) {
	  if (typeof style !== 'string') {
	    throw new TypeError('First argument must be a string');
	  }
	
	  if (!style) return [];
	
	  options = options || {};
	
	  /**
	   * Positional.
	   */
	  var lineno = 1;
	  var column = 1;
	
	  /**
	   * Update lineno and column based on `str`.
	   *
	   * @param {String} str
	   */
	  function updatePosition(str) {
	    var lines = str.match(NEWLINE_REGEX);
	    if (lines) lineno += lines.length;
	    var i = str.lastIndexOf(NEWLINE);
	    column = ~i ? str.length - i : column + str.length;
	  }
	
	  /**
	   * Mark position and patch `node.position`.
	   *
	   * @return {Function}
	   */
	  function position() {
	    var start = { line: lineno, column: column };
	    return function(node) {
	      node.position = new Position(start);
	      whitespace();
	      return node;
	    };
	  }
	
	  /**
	   * Store position information for a node.
	   *
	   * @constructor
	   * @property {Object} start
	   * @property {Object} end
	   * @property {undefined|String} source
	   */
	  function Position(start) {
	    this.start = start;
	    this.end = { line: lineno, column: column };
	    this.source = options.source;
	  }
	
	  /**
	   * Non-enumerable source string.
	   */
	  Position.prototype.content = style;
	
	  var errorsList = [];
	
	  /**
	   * Error `msg`.
	   *
	   * @param {String} msg
	   * @throws {Error}
	   */
	  function error(msg) {
	    var err = new Error(
	      options.source + ':' + lineno + ':' + column + ': ' + msg
	    );
	    err.reason = msg;
	    err.filename = options.source;
	    err.line = lineno;
	    err.column = column;
	    err.source = style;
	
	    if (options.silent) {
	      errorsList.push(err);
	    } else {
	      throw err;
	    }
	  }
	
	  /**
	   * Match `re` and return captures.
	   *
	   * @param {RegExp} re
	   * @return {undefined|Array}
	   */
	  function match(re) {
	    var m = re.exec(style);
	    if (!m) return;
	    var str = m[0];
	    updatePosition(str);
	    style = style.slice(str.length);
	    return m;
	  }
	
	  /**
	   * Parse whitespace.
	   */
	  function whitespace() {
	    match(WHITESPACE_REGEX);
	  }
	
	  /**
	   * Parse comments.
	   *
	   * @param {Object[]} [rules]
	   * @return {Object[]}
	   */
	  function comments(rules) {
	    var c;
	    rules = rules || [];
	    while ((c = comment())) {
	      if (c !== false) {
	        rules.push(c);
	      }
	    }
	    return rules;
	  }
	
	  /**
	   * Parse comment.
	   *
	   * @return {Object}
	   * @throws {Error}
	   */
	  function comment() {
	    var pos = position();
	    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
	
	    var i = 2;
	    while (
	      EMPTY_STRING != style.charAt(i) &&
	      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
	    ) {
	      ++i;
	    }
	    i += 2;
	
	    if (EMPTY_STRING === style.charAt(i - 1)) {
	      return error('End of comment missing');
	    }
	
	    var str = style.slice(2, i - 2);
	    column += 2;
	    updatePosition(str);
	    style = style.slice(i);
	    column += 2;
	
	    return pos({
	      type: TYPE_COMMENT,
	      comment: str
	    });
	  }
	
	  /**
	   * Parse declaration.
	   *
	   * @return {Object}
	   * @throws {Error}
	   */
	  function declaration() {
	    var pos = position();
	
	    // prop
	    var prop = match(PROPERTY_REGEX);
	    if (!prop) return;
	    comment();
	
	    // :
	    if (!match(COLON_REGEX)) return error("property missing ':'");
	
	    // val
	    var val = match(VALUE_REGEX);
	
	    var ret = pos({
	      type: TYPE_DECLARATION,
	      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
	      value: val
	        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
	        : EMPTY_STRING
	    });
	
	    // ;
	    match(SEMICOLON_REGEX);
	
	    return ret;
	  }
	
	  /**
	   * Parse declarations.
	   *
	   * @return {Object[]}
	   */
	  function declarations() {
	    var decls = [];
	
	    comments(decls);
	
	    // declarations
	    var decl;
	    while ((decl = declaration())) {
	      if (decl !== false) {
	        decls.push(decl);
	        comments(decls);
	      }
	    }
	
	    return decls;
	  }
	
	  whitespace();
	  return declarations();
	};
	
	/**
	 * Trim `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 */
	function trim(str) {
	  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
	}


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var debug = __webpack_require__(1408)('jsonp');
	
	/**
	 * Module exports.
	 */
	
	module.exports = jsonp;
	
	/**
	 * Callback index.
	 */
	
	var count = 0;
	
	/**
	 * Noop function.
	 */
	
	function noop(){}
	
	/**
	 * JSONP handler
	 *
	 * Options:
	 *  - param {String} qs parameter (`callback`)
	 *  - prefix {String} qs parameter (`__jp`)
	 *  - name {String} qs parameter (`prefix` + incr)
	 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
	 *
	 * @param {String} url
	 * @param {Object|Function} optional options / callback
	 * @param {Function} optional callback
	 */
	
	function jsonp(url, opts, fn){
	  if ('function' == typeof opts) {
	    fn = opts;
	    opts = {};
	  }
	  if (!opts) opts = {};
	
	  var prefix = opts.prefix || '__jp';
	
	  // use the callback name that was passed if one was provided.
	  // otherwise generate a unique name by incrementing our counter.
	  var id = opts.name || (prefix + (count++));
	
	  var param = opts.param || 'callback';
	  var timeout = null != opts.timeout ? opts.timeout : 60000;
	  var enc = encodeURIComponent;
	  var target = document.getElementsByTagName('script')[0] || document.head;
	  var script;
	  var timer;
	
	
	  if (timeout) {
	    timer = setTimeout(function(){
	      cleanup();
	      if (fn) fn(new Error('Timeout'));
	    }, timeout);
	  }
	
	  function cleanup(){
	    if (script.parentNode) script.parentNode.removeChild(script);
	    window[id] = noop;
	    if (timer) clearTimeout(timer);
	  }
	
	  function cancel(){
	    if (window[id]) {
	      cleanup();
	    }
	  }
	
	  window[id] = function(data){
	    debug('jsonp got', data);
	    cleanup();
	    if (fn) fn(null, data);
	  };
	
	  // add qs component
	  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
	  url = url.replace('?&', '?');
	
	  debug('jsonp req "%s"', url);
	
	  // create script
	  script = document.createElement('script');
	  script.src = url;
	  target.parentNode.insertBefore(script, target);
	
	  return cancel;
	}


/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(72),
	    shuffleSelf = __webpack_require__(99);
	
	/**
	 * A specialized version of `_.shuffle` for arrays.
	 *
	 * @private
	 * @param {Array} array The array to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 */
	function arrayShuffle(array) {
	  return shuffleSelf(copyArray(array));
	}
	
	module.exports = arrayShuffle;


/***/ }),

/***/ 275:
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeRandom = Math.random;
	
	/**
	 * The base implementation of `_.random` without support for returning
	 * floating-point numbers.
	 *
	 * @private
	 * @param {number} lower The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the random number.
	 */
	function baseRandom(lower, upper) {
	  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	}
	
	module.exports = baseRandom;


/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	var shuffleSelf = __webpack_require__(99),
	    values = __webpack_require__(504);
	
	/**
	 * The base implementation of `_.shuffle`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 */
	function baseShuffle(collection) {
	  return shuffleSelf(values(collection));
	}
	
	module.exports = baseShuffle;


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	var baseRandom = __webpack_require__(275);
	
	/**
	 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	 *
	 * @private
	 * @param {Array} array The array to shuffle.
	 * @param {number} [size=array.length] The size of `array`.
	 * @returns {Array} Returns `array`.
	 */
	function shuffleSelf(array, size) {
	  var index = -1,
	      length = array.length,
	      lastIndex = length - 1;
	
	  size = size === undefined ? length : size;
	  while (++index < size) {
	    var rand = baseRandom(index, lastIndex),
	        value = array[rand];
	
	    array[rand] = array[index];
	    array[index] = value;
	  }
	  array.length = size;
	  return array;
	}
	
	module.exports = shuffleSelf;


/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

	var arrayShuffle = __webpack_require__(272),
	    baseShuffle = __webpack_require__(278),
	    isArray = __webpack_require__(25);
	
	/**
	 * Creates an array of shuffled values, using a version of the
	 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 * @example
	 *
	 * _.shuffle([1, 2, 3, 4]);
	 * // => [4, 1, 3, 2]
	 */
	function shuffle(collection) {
	  var func = isArray(collection) ? arrayShuffle : baseShuffle;
	  return func(collection);
	}
	
	module.exports = shuffle;


/***/ }),

/***/ 2249:
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),

/***/ 2350:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmailIcon = (0, _iconFactory2.default)('email', {
	  icon: 'M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z',
	  mask: 'M41.1,25H22.9l9.1,7.1L41.1,25z M44,26.6l-12,9.3l-12-9.3V39h24V26.6z M0,0v64h64V0H0z M47,42H17V22h30V42z',
	  color: '#7f7f7f'
	});
	
	exports.default = EmailIcon;

/***/ }),

/***/ 2351:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function emailLink(url, _ref) {
	  var subject = _ref.subject,
	      body = _ref.body;
	
	  return 'mailto:' + (0, _objectToGetParams2.default)({ subject: subject, body: body || url });
	}
	
	var EmailShareButton = (0, _createShareButton2.default)('email', emailLink, function (props) {
	  return {
	    subject: props.subject,
	    body: props.body
	  };
	}, {
	  subject: _propTypes2.default.string,
	  body: _propTypes2.default.string
	}, {
	  openWindow: false,
	  onClick: function onClick(link) {
	    window.location.href = link;
	  }
	});
	
	exports.default = EmailShareButton;

/***/ }),

/***/ 2352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FacebookIcon = (0, _iconFactory2.default)('facebook', {
	  icon: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
	  mask: 'M0,0v64h64V0H0z M39.6,22l-2.8,0c-2.2,0-2.6,1.1-2.6,2.6V28h5.3l-0.7,5.3h-4.6V47h-5.5V33.3H24V28h4.6V24 c0-4.6,2.8-7,6.9-7c2,0,3.6,0.1,4.1,0.2V22z',
	  color: '#3b5998'
	});
	
	exports.default = FacebookIcon;

/***/ }),

/***/ 2353:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function facebookLink(url, _ref) {
	  var quote = _ref.quote,
	      hashtag = _ref.hashtag;
	
	  (0, _assert2.default)(url, 'facebook.url');
	
	  return 'https://www.facebook.com/sharer/sharer.php' + (0, _objectToGetParams2.default)({
	    u: url,
	    quote: quote,
	    hashtag: hashtag
	  });
	}
	
	var FacebookShareButton = (0, _createShareButton2.default)('facebook', facebookLink, function (props) {
	  /* eslint-disable no-console */
	  if (props.picture) {
	    console.warn('FacebookShareButton warning: picture is a deprecated prop.');
	  }
	
	  if (props.title) {
	    console.warn('FacebookShareButton warning: title is a deprecated prop. Use "quote" instead.');
	  }
	
	  if (props.description) {
	    console.warn('FacebookShareButton warning: description is a deprecated prop.\n      Use "quote" instead.');
	  }
	  /* eslint-enable no-console */
	
	  return {
	    quote: props.quote,
	    hashtag: props.hashtag
	  };
	}, {
	  quote: _propTypes2.default.string,
	  hashtag: _propTypes2.default.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	exports.default = FacebookShareButton;

/***/ }),

/***/ 2354:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsonp = __webpack_require__(129);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _shareCountFactory = __webpack_require__(101);
	
	var _shareCountFactory2 = _interopRequireDefault(_shareCountFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFacebookShareCount(shareUrl, callback) {
	  var endpoint = 'https://graph.facebook.com/?id=' + shareUrl;
	
	  (0, _jsonp2.default)(endpoint, function (err, data) {
	    callback(!err && data && data.share && data.share.share_count ? data.share.share_count : undefined);
	  });
	}
	
	exports.default = (0, _shareCountFactory2.default)(getFacebookShareCount);

/***/ }),

/***/ 2355:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GooglePlusIcon = (0, _iconFactory2.default)('google', {
	  icon: 'M25.3,30.1v3.8h6.3c-0.3,1.6-1.9,4.8-6.3,4.8c-3.8,0-6.9-3.1-6.9-7s3.1-7,6.9-7c2.2,0,3.6,0.9,4.4,1.7l3-2.9c-1.9-1.8-4.4-2.9-7.4-2.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.4,0,10.7-4.5,10.7-10.9c0-0.7-0.1-1.3-0.2-1.8H25.3L25.3,30.1z M49.8,28.9h-3.2v-3.2h-3.2v3.2h-3.2v3.2h3.2v3.2h3.2v-3.2h3.2',
	  mask: 'M0,0v64h64V0H0z M31.3,19.1c0.3,0.3,0.6,0.7,0.9,1.2c0.3,0.4,0.5,0.9,0.7,1.5c0.2,0.6,0.3,1.3,0.3,2.1 c0,1.4-0.3,2.6-0.9,3.4c-0.3,0.4-0.6,0.8-0.9,1.2c-0.4,0.4-0.8,0.7-1.2,1.1c-0.2,0.2-0.5,0.5-0.7,0.8c-0.2,0.3-0.4,0.7-0.4,1.1 c0,0.4,0.1,0.8,0.4,1c0.2,0.3,0.4,0.5,0.6,0.7l1.4,1.1c0.8,0.7,1.6,1.5,2.2,2.3c0.6,0.8,0.9,2,0.9,3.3c0,1.9-0.9,3.7-2.6,5.2 c-1.8,1.6-4.3,2.4-7.7,2.4c-2.8,0-4.9-0.6-6.3-1.8c-1.4-1.1-2.1-2.4-2.1-3.9c0-0.7,0.2-1.6,0.7-2.5c0.4-0.9,1.2-1.7,2.4-2.4 c1.3-0.7,2.7-1.2,4.1-1.5c1.4-0.2,2.6-0.3,3.5-0.4c-0.3-0.4-0.5-0.8-0.8-1.2c-0.3-0.4-0.4-0.9-0.4-1.5c0-0.4,0-0.6,0.2-0.9 c0.1-0.2,0.2-0.5,0.2-0.7c-0.5,0.1-0.9,0.1-1.3,0.1c-2.1,0-3.8-0.7-4.9-2c-1.2-1.2-1.8-2.7-1.8-4.3c0-2,0.8-3.8,2.5-5.4 c1.1-0.9,2.3-1.6,3.5-1.8c1.2-0.2,2.3-0.4,3.4-0.4h8L33,18.4h-2.5C30.7,18.6,31,18.8,31.3,19.1z M48,32h-4.3v4.2h-2.5V32H37v-2.5 h4.2v-4.3h2.5v4.3H48V32z M27.1,19.1c-0.6-0.5-1.4-0.7-2.2-0.7c-1.1,0-2,0.5-2.7,1.3c-0.6,0.9-0.9,1.9-0.9,3c0,1.5,0.4,3,1.3,4.5 c0.4,0.7,0.9,1.4,1.6,1.9c0.6,0.5,1.4,0.8,2.2,0.8c1.1,0,1.9-0.4,2.6-1.1c0.3-0.5,0.6-1,0.7-1.6c0.1-0.5,0.1-1,0.1-1.4 c0-1.6-0.4-3.2-1.2-4.8C28.2,20.2,27.7,19.5,27.1,19.1z M26.9,36.2c-0.2,0-0.7,0-1.6,0.1c-0.8,0.1-1.7,0.3-2.5,0.6 c-0.2,0.1-0.5,0.2-0.9,0.4c-0.4,0.2-0.7,0.4-1.1,0.7c-0.4,0.3-0.7,0.7-0.9,1.2c-0.3,0.5-0.4,1.1-0.4,1.8c0,1.4,0.6,2.6,1.9,3.5 c1.2,0.9,2.9,1.4,5,1.4c1.9,0,3.3-0.4,4.3-1.3c1-0.8,1.5-1.8,1.5-3.1c0-1-0.3-1.9-1-2.7c-0.7-0.7-1.8-1.6-3.3-2.6 C27.5,36.2,27.2,36.2,26.9,36.2z',
	  color: '#dd4b39'
	});
	
	exports.default = GooglePlusIcon;

/***/ }),

/***/ 2356:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function googlePlusLink(url) {
	  (0, _assert2.default)(url, 'googlePlus.url');
	
	  return 'https://plus.google.com/share' + (0, _objectToGetParams2.default)({ url: url });
	}
	
	var GooglePlusShareButton = (0, _createShareButton2.default)('googlePlus', googlePlusLink, undefined, undefined, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	exports.default = GooglePlusShareButton;

/***/ }),

/***/ 2357:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(956);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _ieDetection = __webpack_require__(1065);
	
	var _ieDetection2 = _interopRequireDefault(_ieDetection);
	
	var _shareCountFactory = __webpack_require__(101);
	
	var _shareCountFactory2 = _interopRequireDefault(_shareCountFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getGooglePlusShareCount(shareUrl, callback) {
	  if ((0, _ieDetection2.default)(11)) {
	    /* eslint-disable no-console */
	    console.error('Google plus share count is not supported in <=IE10!');
	    /* eslint-enable no-console */
	    return;
	  }
	
	  var xhr = new XMLHttpRequest();
	
	  xhr.open('POST', 'https://clients6.google.com/rpc');
	  xhr.setRequestHeader('Accept', 'application/json');
	  xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
	
	  xhr.send((0, _stringify2.default)({
	    method: 'pos.plusones.get',
	    id: 'p',
	    params: {
	      nolog: true,
	      id: shareUrl,
	      source: 'widget',
	      userId: '@viewer',
	      groupId: '@self'
	    },
	    jsonrpc: '2.0',
	    key: 'p',
	    apiVersion: 'v1'
	  }));
	
	  xhr.onload = function onSuccessdata() {
	    var data = JSON.parse(this.responseText);
	    callback(data ? data.result.metadata.globalCounts.count : undefined);
	  };
	
	  xhr.onerror = function onErrordata() {};
	}
	
	exports.default = (0, _shareCountFactory2.default)(getGooglePlusShareCount);

/***/ }),

/***/ 2358:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LineIcon = (0, _iconFactory2.default)('line', {
	  icon: 'M52.62 30.138c0 3.693-1.432 7.019-4.42 10.296h.001c-4.326 4.979-14 11.044-16.201 11.972-2.2.927-1.876-.591-1.786-1.112l.294-1.765c.069-.527.142-1.343-.066-1.865-.232-.574-1.146-.872-1.817-1.016-9.909-1.31-17.245-8.238-17.245-16.51 0-9.226 9.251-16.733 20.62-16.733 11.37 0 20.62 7.507 20.62 16.733zM27.81 25.68h-1.446a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-8.985a.402.402 0 0 0-.402-.401zm9.956 0H36.32a.402.402 0 0 0-.402.401v5.338L31.8 25.858a.39.39 0 0 0-.031-.04l-.002-.003-.024-.025-.008-.007a.313.313 0 0 0-.032-.026.255.255 0 0 1-.021-.014l-.012-.007-.021-.012-.013-.006-.023-.01-.013-.005-.024-.008-.014-.003-.023-.005-.017-.002-.021-.003-.021-.002h-1.46a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-5.337l4.123 5.568c.028.04.063.072.101.099l.004.003a.236.236 0 0 0 .025.015l.012.006.019.01a.154.154 0 0 1 .019.008l.012.004.028.01.005.001a.442.442 0 0 0 .104.013h1.446a.4.4 0 0 0 .401-.4v-8.985a.402.402 0 0 0-.401-.401zm-13.442 7.537h-3.93v-7.136a.401.401 0 0 0-.401-.401h-1.447a.4.4 0 0 0-.401.401v8.984a.392.392 0 0 0 .123.29c.072.068.17.111.278.111h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401zm21.429-5.287c.222 0 .401-.18.401-.402v-1.446a.401.401 0 0 0-.401-.402h-5.778a.398.398 0 0 0-.279.113l-.005.004-.006.008a.397.397 0 0 0-.111.276v8.984c0 .108.043.206.112.278l.005.006a.401.401 0 0 0 .284.117h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401h-3.93v-1.519h3.93c.222 0 .401-.18.401-.402V29.85a.401.401 0 0 0-.401-.402h-3.93V27.93h3.93z',
	  mask: '',
	  color: '#00b800'
	});
	
	exports.default = LineIcon;

/***/ }),

/***/ 2359:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function lineLink(url, _ref) {
	  var title = _ref.title;
	
	  (0, _assert2.default)(url, 'line.url');
	
	  return 'https://social-plugins.line.me/lineit/share' + (0, _objectToGetParams2.default)({
	    url: url,
	    text: title
	  });
	}
	
	var LineShareButton = (0, _createShareButton2.default)('line', lineLink, function (props) {
	  return {
	    title: props.title
	  };
	}, {
	  title: _propTypes2.default.string
	}, {
	  windowWidth: 500,
	  windowHeight: 500
	});
	
	exports.default = LineShareButton;

/***/ }),

/***/ 2360:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LinkedinIcon = (0, _iconFactory2.default)('linkedin', {
	  icon: 'M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z',
	  mask: 'M0,0v64h64V0H0z M25.8,44h-5.4V26.6h5.4V44z M23.1,24.3c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 c1.7,0,3.1,1.4,3.1,3.1C26.2,22.9,24.8,24.3,23.1,24.3z M46,44h-5.4v-8.4c0-2,0-4.6-2.8-4.6c-2.8,0-3.2,2.2-3.2,4.5V44h-5.4V26.6 h5.2V29h0.1c0.7-1.4,2.5-2.8,5.1-2.8c5.5,0,6.5,3.6,6.5,8.3V44z',
	  color: '#007fb1'
	});
	
	exports.default = LinkedinIcon;

/***/ }),

/***/ 2361:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function linkedinLink(url, _ref) {
	  var title = _ref.title,
	      description = _ref.description;
	
	  (0, _assert2.default)(url, 'linkedin.url');
	
	  return 'https://linkedin.com/shareArticle' + (0, _objectToGetParams2.default)({
	    url: url,
	    title: title,
	    summary: description
	  });
	}
	
	var LinkedinShareButton = (0, _createShareButton2.default)('linkedin', linkedinLink, function (props) {
	  return {
	    title: props.title,
	    description: props.description
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string
	}, {
	  windowWidth: 750,
	  windowHeight: 600
	});
	
	exports.default = LinkedinShareButton;

/***/ }),

/***/ 2362:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsonp = __webpack_require__(129);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _shareCountFactory = __webpack_require__(101);
	
	var _shareCountFactory2 = _interopRequireDefault(_shareCountFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getLinkedinShareCount(shareUrl, callback) {
	  var url = 'https://www.linkedin.com/countserv/count/share';
	
	  return (0, _jsonp2.default)(url + (0, _objectToGetParams2.default)({
	    url: shareUrl,
	    format: 'jsonp'
	  }), function (err, data) {
	    callback(data ? data.count : undefined);
	  });
	}
	
	exports.default = (0, _shareCountFactory2.default)(getLinkedinShareCount);

/***/ }),

/***/ 2363:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LivejournalIcon = (0, _iconFactory2.default)('livejournal', {
	  icon: 'M18.3407821,28.1764706 L21.9441341,31.789916 L33.0055865,42.882353 C33.0055865,42.882353 33.0893855,42.9663866 33.0893855,42.9663866 L46.6648046,47 C46.6648046,47 46.6648046,47 46.7486034,47 C46.8324022,47 46.8324022,47 46.9162012,46.9159664 C47,46.8319327 47,46.8319327 47,46.7478991 L42.9776536,33.1344537 C42.9776536,33.1344537 42.9776536,33.1344537 42.8938548,33.0504202 L31.1620111,21.3697479 L31.1620111,21.3697479 L28.1452514,18.2605042 C27.3072626,17.4201681 26.5530726,17 25.7150838,17 C24.2905028,17 23.0335195,18.3445378 21.5251397,19.8571429 C21.273743,20.1092437 20.9385475,20.4453781 20.6871508,20.697479 C20.3519553,21.0336134 20.1005586,21.2857143 19.849162,21.5378151 C18.3407821,22.9663866 17.0837989,24.2268908 17,25.7394958 C17.0837989,26.4957983 17.5027933,27.3361345 18.3407821,28.1764706 Z M39.9012319,39.6134454 C39.7336341,39.4453781 39.4822374,37.6806724 40.2364275,36.8403362 C40.9906174,36.0840337 41.6610084,36 42.1638017,36 C42.3313995,36 42.4989973,36 42.5827961,36 L44.8453659,43.5630253 L43.5883828,44.8235295 L36.0464833,42.5546218 C35.9626843,42.2184874 35.8788855,41.2100841 36.8844722,40.2016807 C37.2196676,39.8655463 37.8900587,39.6134454 38.5604498,39.6134454 C39.147042,39.6134454 39.5660364,39.7815126 39.5660364,39.7815126 C39.6498353,39.8655463 39.8174331,39.8655463 39.8174331,39.7815126 C39.9850307,39.7815126 39.9850307,39.697479 39.9012319,39.6134454 Z',
	  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
	  color: '#21A5D8'
	});
	
	exports.default = LivejournalIcon;

/***/ }),

/***/ 2364:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function livejournalLink(url, _ref) {
	  var title = _ref.title,
	      description = _ref.description;
	
	  (0, _assert2.default)(url, 'livejournal.url');
	
	  return 'https://www.livejournal.com/update.bml' + (0, _objectToGetParams2.default)({
	    subject: title,
	    event: description
	  });
	}
	
	var LivejournalShareButton = (0, _createShareButton2.default)('livejournal', livejournalLink, function (props) {
	  return {
	    title: props.title,
	    description: props.description
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	exports.default = LivejournalShareButton;

/***/ }),

/***/ 2365:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MailruIcon = (0, _iconFactory2.default)('mailru', {
	  icon: 'M39.7107745,17 C41.6619755,17 43.3204965,18.732852 43.3204965,21.0072202 C43.3204965,23.2815885 41.7595357,25.0144404 39.7107745,25.0144404 C37.7595732,25.0144404 36.1010522,23.2815885 36.1010522,21.0072202 C36.1010522,18.732852 37.7595732,17 39.7107745,17 Z M24.3938451,17 C26.3450463,17 28.0035672,18.732852 28.0035672,21.0072202 C28.0035672,23.2815885 26.4426063,25.0144404 24.3938451,25.0144404 C22.4426439,25.0144404 20.7841229,23.2815885 20.7841229,21.0072202 C20.7841229,18.732852 22.4426439,17 24.3938451,17 Z M51.9057817,43.4259928 C51.7106617,44.0758123 51.4179815,44.6173285 50.9301812,44.9422383 C50.637501,45.1588448 50.2472607,45.267148 49.8570205,45.267148 C49.07654,45.267148 48.3936197,44.833935 48.0033795,44.0758123 L46.2472985,40.7184115 L45.759498,41.2599278 C42.5400162,44.9422383 37.466893,47 32.0035297,47 C26.5401664,47 21.5646034,44.9422383 18.2475614,41.2599278 L17.7597611,40.7184115 L16.00368,44.0758123 C15.6134398,44.833935 14.9305194,45.267148 14.1500389,45.267148 C13.7597986,45.267148 13.3695584,45.1588448 13.0768782,44.9422383 C12.0037176,44.2924187 11.7110374,42.7761733 12.2963978,41.5848375 L16.7841605,33.0288807 C17.1744007,32.270758 17.8573211,31.8375453 18.6378016,31.8375453 C19.0280418,31.8375453 19.4182821,31.9458485 19.7109623,32.1624548 C20.7841229,32.8122743 21.0768031,34.3285197 20.4914427,35.5198555 L20.1012025,36.2779783 L20.2963226,36.602888 C22.4426439,39.9602888 27.0279667,42.234657 31.9059697,42.234657 C36.7839727,42.234657 41.3692955,40.068592 43.5156167,36.602888 L43.7107367,36.2779783 L43.3204965,35.6281587 C43.0278165,35.0866425 42.9302562,34.436823 43.1253765,33.7870035 C43.3204965,33.137184 43.6131767,32.5956678 44.100977,32.270758 C44.3936572,32.0541515 44.7838975,31.9458485 45.1741377,31.9458485 C45.9546182,31.9458485 46.6375385,32.3790613 47.0277787,33.137184 L51.5155415,41.6931408 C52.003342,42.234657 52.100902,42.8844765 51.9057817,43.4259928 Z',
	  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
	  color: '#168DE2'
	});
	
	exports.default = MailruIcon;

/***/ }),

/***/ 2366:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mailruLink(url, _ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      image = _ref.image;
	
	  (0, _assert2.default)(url, 'mailru.url');
	
	  return 'https://connect.mail.ru/share' + (0, _objectToGetParams2.default)({
	    url: url,
	    title: title,
	    description: description,
	    imageurl: image
	  });
	}
	
	var MailruShareButton = (0, _createShareButton2.default)('mailru', mailruLink, function (props) {
	  return {
	    title: props.title,
	    description: props.description,
	    image: props.image
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  image: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	exports.default = MailruShareButton;

/***/ }),

/***/ 2367:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OKIcon = (0, _iconFactory2.default)('ok', {
	  icon: 'M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z ',
	  mask: 'M45,1H5C2.8,1,1,2.8,1,5v40c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4V5C49,2.8,47.2,1,45,1z',
	  color: '#f2720c'
	});
	
	exports.default = OKIcon;

/***/ }),

/***/ 2368:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function okLink(url, _ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      image = _ref.image;
	
	  (0, _assert2.default)(url, 'ok.url');
	
	  return 'https://connect.ok.ru/offer' + (0, _objectToGetParams2.default)({
	    url: url,
	    title: title,
	    description: description,
	    imageUrl: image
	  });
	}
	
	var OKShareButton = (0, _createShareButton2.default)('ok', okLink, function (props) {
	  return {
	    title: props.title,
	    description: props.description,
	    image: props.image
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  image: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	exports.default = OKShareButton;

/***/ }),

/***/ 2369:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsonp = __webpack_require__(129);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _shareCountFactory = __webpack_require__(101);
	
	var _shareCountFactory2 = _interopRequireDefault(_shareCountFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getOKShareCount(shareUrl, callback) {
	  if (!window.OK) {
	    window.OK = {
	      Share: {
	        count: function count(index, _count) {
	          return window.OK.callbacks[index](_count);
	        }
	      },
	      callbacks: []
	    };
	  }
	
	  var url = 'https://connect.ok.ru/dk';
	  var index = window.OK.callbacks.length;
	
	  window.ODKL = {
	    updateCount: function updateCount(a, b) {
	      window.OK.callbacks[index](b);
	    }
	  };
	  window.OK.callbacks.push(callback);
	
	  return (0, _jsonp2.default)(url + (0, _objectToGetParams2.default)({
	    'st.cmd': 'extLike',
	    uid: 'odklcnt0',
	    ref: shareUrl
	  }));
	}
	
	exports.default = (0, _shareCountFactory2.default)(getOKShareCount);

/***/ }),

/***/ 2370:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PinterestIcon = (0, _iconFactory2.default)('pinterest', {
	  icon: 'M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z',
	  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
	  color: '#cb2128'
	});
	
	exports.default = PinterestIcon;

/***/ }),

/***/ 2371:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function pinterestLink(url, _ref) {
	  var media = _ref.media,
	      description = _ref.description;
	
	  (0, _assert2.default)(url, 'pinterest.url');
	  (0, _assert2.default)(media, 'pinterest.media');
	
	  return 'https://pinterest.com/pin/create/button/' + (0, _objectToGetParams2.default)({
	    url: url,
	    media: media,
	    description: description
	  });
	}
	
	var PinterestShareButton = (0, _createShareButton2.default)('pinterest', pinterestLink, function (props) {
	  return {
	    media: props.media,
	    description: props.description
	  };
	}, {
	  media: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string
	}, {
	  windowWidth: 1000,
	  windowHeight: 730
	});
	
	exports.default = PinterestShareButton;

/***/ }),

/***/ 2372:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsonp = __webpack_require__(129);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _shareCountFactory = __webpack_require__(101);
	
	var _shareCountFactory2 = _interopRequireDefault(_shareCountFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getPinterestShareCount(shareUrl, callback) {
	  var url = 'https://api.pinterest.com/v1/urls/count.json';
	
	  return (0, _jsonp2.default)(url + (0, _objectToGetParams2.default)({
	    url: shareUrl
	  }), function (err, data) {
	    callback(data ? data.count : undefined);
	  });
	}
	
	exports.default = (0, _shareCountFactory2.default)(getPinterestShareCount);

/***/ }),

/***/ 2373:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RedditIcon = (0, _iconFactory2.default)('reddit', {
	  icon: 'm 52.8165,31.942362 c 0,-2.4803 -2.0264,-4.4965 -4.5169,-4.4965 -1.2155,0 -2.3171,0.4862 -3.128,1.2682 -3.077,-2.0247 -7.2403,-3.3133 -11.8507,-3.4782 l 2.5211,-7.9373 6.8272,1.5997 -0.0102,0.0986 c 0,2.0281 1.6575,3.6771 3.6958,3.6771 2.0366,0 3.6924,-1.649 3.6924,-3.6771 0,-2.0281 -1.6575,-3.6788 -3.6924,-3.6788 -1.564,0 -2.8968,0.9758 -3.4357,2.3443 l -7.3593,-1.7255 c -0.3213,-0.0782 -0.6477,0.1071 -0.748,0.4233 L 32,25.212062 c -4.8246,0.0578 -9.1953,1.3566 -12.41,3.4425 -0.8058,-0.7446 -1.8751,-1.2104 -3.0583,-1.2104 -2.4905,0 -4.5152,2.0179 -4.5152,4.4982 0,1.649 0.9061,3.0787 2.2389,3.8607 -0.0884,0.4794 -0.1462,0.9639 -0.1462,1.4569 0,6.6487 8.1736,12.0581 18.2223,12.0581 10.0487,0 18.224,-5.4094 18.224,-12.0581 0,-0.4658 -0.0493,-0.9248 -0.1275,-1.377 1.4144,-0.7599 2.3885,-2.2304 2.3885,-3.9406 z m -29.2808,3.0872 c 0,-1.4756 1.207,-2.6775 2.6894,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 -1.4824,0 -2.6894,-1.2002 -2.6894,-2.6758 z m 15.4037,7.9373 c -1.3549,1.3481 -3.4816,2.0043 -6.5008,2.0043 l -0.0221,-0.0051 -0.0221,0.0051 c -3.0209,0 -5.1476,-0.6562 -6.5008,-2.0043 -0.2465,-0.2448 -0.2465,-0.6443 0,-0.8891 0.2465,-0.2465 0.6477,-0.2465 0.8942,0 1.105,1.0999 2.9393,1.6337 5.6066,1.6337 l 0.0221,0.0051 0.0221,-0.0051 c 2.6673,0 4.5016,-0.5355 5.6066,-1.6354 0.2465,-0.2465 0.6477,-0.2448 0.8942,0 0.2465,0.2465 0.2465,0.6443 0,0.8908 z m -0.3213,-5.2615 c -1.4824,0 -2.6877,-1.2002 -2.6877,-2.6758 0,-1.4756 1.2053,-2.6775 2.6877,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 z',
	  color: '#5f99cf'
	});
	
	exports.default = RedditIcon;

/***/ }),

/***/ 2374:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function redditLink(url, _ref) {
	  var title = _ref.title;
	
	  (0, _assert2.default)(url, 'reddit.url');
	
	  return 'https://www.reddit.com/submit' + (0, _objectToGetParams2.default)({
	    url: url,
	    title: title
	  });
	}
	
	var RedditShareButton = (0, _createShareButton2.default)('reddit', redditLink, function (props) {
	  return {
	    title: props.title
	  };
	}, {
	  title: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	exports.default = RedditShareButton;

/***/ }),

/***/ 2375:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsonp = __webpack_require__(129);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _shareCountFactory = __webpack_require__(101);
	
	var _shareCountFactory2 = _interopRequireDefault(_shareCountFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRedditShareCount(shareUrl, callback) {
	  var endpoint = 'https://www.reddit.com/api/info.json?limit=1&url=' + shareUrl;
	
	  (0, _jsonp2.default)(endpoint, { param: 'jsonp' }, function (err, response) {
	    callback(!err && response && response.data && response.data.children.length > 0 && response.data.children[0].data.score ? response.data.children[0].data.score : undefined);
	  });
	}
	
	exports.default = (0, _shareCountFactory2.default)(getRedditShareCount);

/***/ }),

/***/ 2376:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TelegramIcon = (0, _iconFactory2.default)('telegram', {
	  icon: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
	  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
	  color: '#37aee2'
	});
	
	exports.default = TelegramIcon;

/***/ }),

/***/ 2377:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function telegramLink(url, _ref) {
	  var title = _ref.title;
	
	  (0, _assert2.default)(url, 'telegram.url');
	
	  return 'https://telegram.me/share/' + (0, _objectToGetParams2.default)({
	    url: url,
	    text: title
	  });
	}
	
	var TelegramShareButton = (0, _createShareButton2.default)('telegram', telegramLink, function (props) {
	  return {
	    title: props.title,
	    via: props.via
	  };
	}, {
	  title: _propTypes2.default.string,
	  via: _propTypes2.default.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	exports.default = TelegramShareButton;

/***/ }),

/***/ 2378:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TumblrIcon = (0, _iconFactory2.default)('tumblr', {
	  icon: 'M39.2,41c-0.6,0.3-1.6,0.5-2.4,0.5c-2.4,0.1-2.9-1.7-2.9-3v-9.3h6v-4.5h-6V17c0,0-4.3,0-4.4,0 c-0.1,0-0.2,0.1-0.2,0.2c-0.3,2.3-1.4,6.4-5.9,8.1v3.9h3V39c0,3.4,2.5,8.1,9,8c2.2,0,4.7-1,5.2-1.8L39.2,41z',
	  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
	  color: '#2c4762'
	});
	
	exports.default = TumblrIcon;

/***/ }),

/***/ 2379:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function tumblrLink(url, _ref) {
	  var title = _ref.title,
	      caption = _ref.caption,
	      tags = _ref.tags,
	      posttype = _ref.posttype;
	
	  (0, _assert2.default)(url, 'tumblr.url');
	
	  return 'https://www.tumblr.com/widgets/share/tool' + (0, _objectToGetParams2.default)({
	    canonicalUrl: url,
	    title: title,
	    caption: caption,
	    tags: tags,
	    posttype: posttype
	  });
	}
	
	var TumblrShareButton = (0, _createShareButton2.default)('tumblr', tumblrLink, function (props) {
	  return {
	    title: props.title,
	    tags: props.tags.join(','),
	    caption: props.caption,
	    posttype: props.posttype
	  };
	}, {
	  title: _propTypes2.default.string,
	  caption: _propTypes2.default.string,
	  posttype: _propTypes2.default.string,
	  tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
	}, {
	  tags: [],
	  posttype: 'link',
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	exports.default = TumblrShareButton;

/***/ }),

/***/ 2380:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsonp = __webpack_require__(129);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _shareCountFactory = __webpack_require__(101);
	
	var _shareCountFactory2 = _interopRequireDefault(_shareCountFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTumblrShareCount(shareUrl, callback) {
	  var endpoint = 'https://api.tumblr.com/v2/share/stats';
	
	  return (0, _jsonp2.default)(endpoint + (0, _objectToGetParams2.default)({
	    url: shareUrl
	  }), function (err, data) {
	    callback(data ? data.note_count : undefined);
	  });
	}
	
	exports.default = (0, _shareCountFactory2.default)(getTumblrShareCount);

/***/ }),

/***/ 2381:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TwitterIcon = (0, _iconFactory2.default)('twitter', {
	  icon: 'M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z',
	  mask: 'M0,0v64h64V0H0z M44.7,25.5c0,0.3,0,0.6,0,0.8C44.7,35,38.1,45,26.1,45c-3.7,0-7.2-1.1-10.1-2.9 c0.5,0.1,1,0.1,1.6,0.1c3.1,0,5.9-1,8.2-2.8c-2.9-0.1-5.3-2-6.1-4.6c0.4,0.1,0.8,0.1,1.2,0.1c0.6,0,1.2-0.1,1.7-0.2 c-3-0.6-5.3-3.3-5.3-6.4c0,0,0-0.1,0-0.1c0.9,0.5,1.9,0.8,3,0.8c-1.8-1.2-2.9-3.2-2.9-5.5c0-1.2,0.3-2.3,0.9-3.3 c3.2,4,8.1,6.6,13.5,6.9c-0.1-0.5-0.2-1-0.2-1.5c0-3.6,2.9-6.6,6.6-6.6c1.9,0,3.6,0.8,4.8,2.1c1.5-0.3,2.9-0.8,4.2-1.6 c-0.5,1.5-1.5,2.8-2.9,3.6c1.3-0.2,2.6-0.5,3.8-1C47.1,23.4,46,24.5,44.7,25.5z',
	  color: '#00aced'
	});
	
	exports.default = TwitterIcon;

/***/ }),

/***/ 2382:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function twitterLink(url, _ref) {
	  var title = _ref.title,
	      via = _ref.via,
	      _ref$hashtags = _ref.hashtags,
	      hashtags = _ref$hashtags === undefined ? [] : _ref$hashtags;
	
	  (0, _assert2.default)(url, 'twitter.url');
	  (0, _assert2.default)(Array.isArray(hashtags), 'twitter.hashtags is not an array');
	
	  return 'https://twitter.com/share' + (0, _objectToGetParams2.default)({
	    url: url,
	    text: title,
	    via: via,
	    hashtags: hashtags.join(',')
	  });
	}
	
	var TwitterShareButton = (0, _createShareButton2.default)('twitter', twitterLink, function (props) {
	  return {
	    hashtags: props.hashtags,
	    title: props.title,
	    via: props.via
	  };
	}, {
	  hashtags: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  title: _propTypes2.default.string,
	  via: _propTypes2.default.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	exports.default = TwitterShareButton;

/***/ }),

/***/ 2383:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VKIcon = (0, _iconFactory2.default)('vk', {
	  icon: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
	  mask: 'M0,0v64h64V0H0z M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
	  color: '#45668e'
	});
	
	exports.default = VKIcon;

/***/ }),

/***/ 2384:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function vkLink(url, _ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      image = _ref.image;
	
	  (0, _assert2.default)(url, 'vk.url');
	
	  return 'https://vk.com/share.php' + (0, _objectToGetParams2.default)({
	    url: url,
	    title: title,
	    description: description,
	    image: image
	  });
	}
	
	var VKShareButton = (0, _createShareButton2.default)('vk', vkLink, function (props) {
	  return {
	    title: props.title,
	    description: props.description,
	    image: props.image
	  };
	}, {
	  title: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  image: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	exports.default = VKShareButton;

/***/ }),

/***/ 2385:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsonp = __webpack_require__(129);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _shareCountFactory = __webpack_require__(101);
	
	var _shareCountFactory2 = _interopRequireDefault(_shareCountFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getVKShareCount(shareUrl, callback) {
	  if (!window.VK) {
	    window.VK = {
	      Share: {
	        count: function count(index, _count) {
	          return window.VK.callbacks[index](_count);
	        }
	      },
	      callbacks: []
	    };
	  }
	
	  var url = 'https://vk.com/share.php';
	  var index = window.VK.callbacks.length;
	
	  window.VK.callbacks.push(callback);
	
	  return (0, _jsonp2.default)(url + (0, _objectToGetParams2.default)({
	    act: 'count',
	    index: index,
	    url: shareUrl
	  }));
	}
	
	exports.default = (0, _shareCountFactory2.default)(getVKShareCount);

/***/ }),

/***/ 2386:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ViberIcon = (0, _iconFactory2.default)('viber', {
	  icon: 'm31.0,12.3c9.0,0.2 16.4,6.2 18.0,15.2c0.2,1.5 0.3,3.0 0.4,4.6a1.0,1.0 0 0 1 -0.8,1.2l-0.1,0a1.1,1.1 0 0 1 -1.0,-1.2l0,0c-0.0,-1.2 -0.1,-2.5 -0.3,-3.8a16.1,16.1 0 0 0 -13.0,-13.5c-1.0,-0.1 -2.0,-0.2 -3.0,-0.3c-0.6,-0.0 -1.4,-0.1 -1.6,-0.8a1.1,1.1 0 0 1 0.9,-1.2l0.6,0l0.0,-0.0zm10.6,39.2a19.9,19.9 0 0 1 -2.1,-0.6c-6.9,-2.9 -13.2,-6.6 -18.3,-12.2a47.5,47.5 0 0 1 -7.0,-10.7c-0.8,-1.8 -1.6,-3.7 -2.4,-5.6c-0.6,-1.7 0.3,-3.4 1.4,-4.7a11.3,11.3 0 0 1 3.7,-2.8a2.4,2.4 0 0 1 3.0,0.7a39.0,39.0 0 0 1 4.7,6.5a3.1,3.1 0 0 1 -0.8,4.2c-0.3,0.2 -0.6,0.5 -1.0,0.8a3.3,3.3 0 0 0 -0.7,0.7a2.1,2.1 0 0 0 -0.1,1.9c1.7,4.9 4.7,8.7 9.7,10.8a5.0,5.0 0 0 0 2.5,0.6c1.5,-0.1 2.0,-1.8 3.1,-2.7a2.9,2.9 0 0 1 3.5,-0.1c1.1,0.7 2.2,1.4 3.3,2.2a37.8,37.8 0 0 1 3.1,2.4a2.4,2.4 0 0 1 0.7,3.0a10.4,10.4 0 0 1 -4.4,4.8a10.8,10.8 0 0 1 -1.9,0.6c-0.7,-0.2 0.6,-0.2 0,0l0.0,0l0,-0.0zm3.1,-21.4a4.2,4.2 0 0 1 -0.0,0.6a1.0,1.0 0 0 1 -1.9,0.1a2.7,2.7 0 0 1 -0.1,-0.8a10.9,10.9 0 0 0 -1.4,-5.5a10.2,10.2 0 0 0 -4.2,-4.0a12.3,12.3 0 0 0 -3.4,-1.0c-0.5,-0.0 -1.0,-0.1 -1.5,-0.2a0.9,0.9 0 0 1 -0.9,-1.0l0,-0.1a0.9,0.9 0 0 1 0.9,-0.9l0.1,0a14.1,14.1 0 0 1 5.9,1.5a11.9,11.9 0 0 1 6.5,9.3c0,0.1 0.0,0.3 0.0,0.5c0,0.4 0.0,0.9 0.0,1.5l0,0l0.0,0.0zm-5.6,-0.2a1.1,1.1 0 0 1 -1.2,-0.9l0,-0.1a11.3,11.3 0 0 0 -0.2,-1.4a4.0,4.0 0 0 0 -1.5,-2.3a3.9,3.9 0 0 0 -1.2,-0.5c-0.5,-0.1 -1.1,-0.1 -1.6,-0.2a1.0,1.0 0 0 1 -0.8,-1.1l0,0l0,0a1.0,1.0 0 0 1 1.1,-0.8c3.4,0.2 6.0,2.0 6.3,6.2a2.8,2.8 0 0 1 0,0.8a0.8,0.8 0 0 1 -0.8,0.7l0,0l0.0,-0.0z',
	  mask: '',
	  color: '#7C529E'
	});
	
	exports.default = ViberIcon;

/***/ }),

/***/ 2387:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function viberLink(url, _ref) {
	  var title = _ref.title;
	
	  (0, _assert2.default)(url, 'viber.url');
	  return 'viber://forward' + (0, _objectToGetParams2.default)({
	    text: (title || '') + ' ' + url
	  });
	}
	
	var ViberShareButton = (0, _createShareButton2.default)('viber', viberLink, function (props) {
	  return {
	    title: props.title
	  };
	}, {
	  title: _propTypes2.default.string
	}, {
	  windowWidth: 660,
	  windowHeight: 460
	});
	
	exports.default = ViberShareButton;

/***/ }),

/***/ 2388:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function weiboLink(url, _ref) {
	  var title = _ref.title,
	      image = _ref.image;
	
	  (0, _assert2.default)(url, 'weibo.url');
	  (0, _assert2.default)(image, 'weibo.image');
	
	  return 'http://service.weibo.com/share/share.php?' + (0, _objectToGetParams2.default)({
	    url: url,
	    title: title,
	    pic: image
	  });
	}
	
	var WeiboShareButton = (0, _createShareButton2.default)('weibo', weiboLink, function (props) {
	  return {
	    title: props.title,
	    image: props.image
	  };
	}, {
	  title: _propTypes2.default.string,
	  image: _propTypes2.default.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	exports.default = WeiboShareButton;

/***/ }),

/***/ 2389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WhatsappIcon = (0, _iconFactory2.default)('whatsapp', {
	  icon: 'm42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915',
	  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
	  color: '#2cb742'
	});
	
	exports.default = WhatsappIcon;

/***/ }),

/***/ 2390:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function whatsappLink(url, _ref) {
	  var title = _ref.title,
	      separator = _ref.separator;
	
	  (0, _assert2.default)(url, 'whatsapp.url');
	  return 'https://api.whatsapp.com/send' + (0, _objectToGetParams2.default)({
	    text: title ? title + separator + url : url
	  });
	}
	
	var WhatsappShareButton = (0, _createShareButton2.default)('whatsapp', whatsappLink, function (props) {
	  return {
	    title: props.title,
	    separator: props.separator
	  };
	}, {
	  title: _propTypes2.default.string,
	  separator: _propTypes2.default.string
	}, {
	  separator: ' ',
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	exports.default = WhatsappShareButton;

/***/ }),

/***/ 2391:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iconFactory = __webpack_require__(42);
	
	var _iconFactory2 = _interopRequireDefault(_iconFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorkplaceIcon = (0, _iconFactory2.default)('workplace', {
	  icon: 'M34.019,10.292c0.21,0.017,0.423,0.034,0.636,0.049 c3.657,0.262,6.976,1.464,9.929,3.635c3.331,2.448,5.635,5.65,6.914,9.584c0.699,2.152,0.983,4.365,0.885,6.623 c-0.136,3.171-1.008,6.13-2.619,8.867c-0.442,0.75-0.908,1.492-1.495,2.141c-0.588,0.651-1.29,1.141-2.146,1.383 c-1.496,0.426-3.247-0.283-3.961-1.642c-0.26-0.494-0.442-1.028-0.654-1.548c-1.156-2.838-2.311-5.679-3.465-8.519 c-0.017-0.042-0.037-0.082-0.065-0.145c-0.101,0.245-0.192,0.472-0.284,0.698c-1.237,3.051-2.475,6.103-3.711,9.155 c-0.466,1.153-1.351,1.815-2.538,2.045c-1.391,0.267-2.577-0.154-3.496-1.247c-0.174-0.209-0.31-0.464-0.415-0.717 c-2.128-5.22-4.248-10.442-6.37-15.665c-0.012-0.029-0.021-0.059-0.036-0.104c0.054-0.003,0.103-0.006,0.15-0.006 c1.498-0.001,2.997,0,4.495-0.004c0.12-0.001,0.176,0.03,0.222,0.146c1.557,3.846,3.117,7.691,4.679,11.536 c0.018,0.046,0.039,0.091,0.067,0.159c0.273-0.673,0.536-1.32,0.797-1.968c1.064-2.627,2.137-5.25,3.19-7.883 c0.482-1.208,1.376-1.917,2.621-2.135c1.454-0.255,2.644,0.257,3.522,1.449c0.133,0.18,0.229,0.393,0.313,0.603 c1.425,3.495,2.848,6.991,4.269,10.488c0.02,0.047,0.04,0.093,0.073,0.172c0.196-0.327,0.385-0.625,0.559-0.935 c0.783-1.397,1.323-2.886,1.614-4.461c0.242-1.312,0.304-2.634,0.187-3.962c-0.242-2.721-1.16-5.192-2.792-7.38 c-2.193-2.939-5.086-4.824-8.673-5.625c-1.553-0.346-3.124-0.405-4.705-0.257c-3.162,0.298-6.036,1.366-8.585,3.258 c-3.414,2.534-5.638,5.871-6.623,10.016c-0.417,1.76-0.546,3.547-0.384,5.348c0.417,4.601,2.359,8.444,5.804,11.517 c2.325,2.073,5.037,3.393,8.094,3.989c1.617,0.317,3.247,0.395,4.889,0.242c1-0.094,1.982-0.268,2.952-0.529 c0.04-0.01,0.081-0.018,0.128-0.028c0,1.526,0,3.047,0,4.586c-0.402,0.074-0.805,0.154-1.21,0.221 c-0.861,0.14-1.728,0.231-2.601,0.258c-0.035,0.002-0.071,0.013-0.108,0.021c-0.493,0-0.983,0-1.476,0 c-0.049-0.007-0.1-0.018-0.149-0.022c-0.315-0.019-0.629-0.033-0.945-0.058c-1.362-0.105-2.702-0.346-4.017-0.716 c-3.254-0.914-6.145-2.495-8.66-4.752c-2.195-1.971-3.926-4.29-5.176-6.963c-1.152-2.466-1.822-5.057-1.993-7.774 c-0.014-0.226-0.033-0.451-0.05-0.676c0-0.502,0-1.003,0-1.504c0.008-0.049,0.02-0.099,0.022-0.148 c0.036-1.025,0.152-2.043,0.338-3.052c0.481-2.616,1.409-5.066,2.8-7.331c2.226-3.625,5.25-6.386,9.074-8.254 c2.536-1.24,5.217-1.947,8.037-2.126c0.23-0.015,0.461-0.034,0.691-0.051C33.052,10.292,33.535,10.292,34.019,10.292z',
	  color: '#3b3d4a'
	});
	
	exports.default = WorkplaceIcon;

/***/ }),

/***/ 2392:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _assert = __webpack_require__(40);
	
	var _assert2 = _interopRequireDefault(_assert);
	
	var _objectToGetParams = __webpack_require__(32);
	
	var _objectToGetParams2 = _interopRequireDefault(_objectToGetParams);
	
	var _createShareButton = __webpack_require__(39);
	
	var _createShareButton2 = _interopRequireDefault(_createShareButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function workplaceLink(url, _ref) {
	  var quote = _ref.quote,
	      hashtag = _ref.hashtag;
	
	  (0, _assert2.default)(url, 'workplace.url');
	
	  return 'https://work.facebook.com/sharer.php' + (0, _objectToGetParams2.default)({
	    u: url,
	    quote: quote,
	    hashtag: hashtag
	  });
	}
	
	var WorkplaceShareButton = (0, _createShareButton2.default)('workplace', workplaceLink, function (props) {
	  return {
	    quote: props.quote,
	    hashtag: props.hashtag
	  };
	}, {
	  quote: _propTypes2.default.string,
	  hashtag: _propTypes2.default.string
	}, {
	  windowWidth: 550,
	  windowHeight: 400
	});
	
	exports.default = WorkplaceShareButton;

/***/ }),

/***/ 2393:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FacebookShareCount = __webpack_require__(2354);
	
	Object.defineProperty(exports, 'FacebookShareCount', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FacebookShareCount).default;
	  }
	});
	
	var _GooglePlusShareCount = __webpack_require__(2357);
	
	Object.defineProperty(exports, 'GooglePlusShareCount', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GooglePlusShareCount).default;
	  }
	});
	
	var _LinkedinShareCount = __webpack_require__(2362);
	
	Object.defineProperty(exports, 'LinkedinShareCount', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkedinShareCount).default;
	  }
	});
	
	var _PinterestShareCount = __webpack_require__(2372);
	
	Object.defineProperty(exports, 'PinterestShareCount', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PinterestShareCount).default;
	  }
	});
	
	var _VKShareCount = __webpack_require__(2385);
	
	Object.defineProperty(exports, 'VKShareCount', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VKShareCount).default;
	  }
	});
	
	var _OKShareCount = __webpack_require__(2369);
	
	Object.defineProperty(exports, 'OKShareCount', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OKShareCount).default;
	  }
	});
	
	var _RedditShareCount = __webpack_require__(2375);
	
	Object.defineProperty(exports, 'RedditShareCount', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RedditShareCount).default;
	  }
	});
	
	var _TumblrShareCount = __webpack_require__(2380);
	
	Object.defineProperty(exports, 'TumblrShareCount', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TumblrShareCount).default;
	  }
	});
	
	var _FacebookShareButton = __webpack_require__(2353);
	
	Object.defineProperty(exports, 'FacebookShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FacebookShareButton).default;
	  }
	});
	
	var _GooglePlusShareButton = __webpack_require__(2356);
	
	Object.defineProperty(exports, 'GooglePlusShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GooglePlusShareButton).default;
	  }
	});
	
	var _LinkedinShareButton = __webpack_require__(2361);
	
	Object.defineProperty(exports, 'LinkedinShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkedinShareButton).default;
	  }
	});
	
	var _TwitterShareButton = __webpack_require__(2382);
	
	Object.defineProperty(exports, 'TwitterShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TwitterShareButton).default;
	  }
	});
	
	var _PinterestShareButton = __webpack_require__(2371);
	
	Object.defineProperty(exports, 'PinterestShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PinterestShareButton).default;
	  }
	});
	
	var _VKShareButton = __webpack_require__(2384);
	
	Object.defineProperty(exports, 'VKShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VKShareButton).default;
	  }
	});
	
	var _OKShareButton = __webpack_require__(2368);
	
	Object.defineProperty(exports, 'OKShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OKShareButton).default;
	  }
	});
	
	var _TelegramShareButton = __webpack_require__(2377);
	
	Object.defineProperty(exports, 'TelegramShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TelegramShareButton).default;
	  }
	});
	
	var _WhatsappShareButton = __webpack_require__(2390);
	
	Object.defineProperty(exports, 'WhatsappShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WhatsappShareButton).default;
	  }
	});
	
	var _RedditShareButton = __webpack_require__(2374);
	
	Object.defineProperty(exports, 'RedditShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RedditShareButton).default;
	  }
	});
	
	var _EmailShareButton = __webpack_require__(2351);
	
	Object.defineProperty(exports, 'EmailShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EmailShareButton).default;
	  }
	});
	
	var _TumblrShareButton = __webpack_require__(2379);
	
	Object.defineProperty(exports, 'TumblrShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TumblrShareButton).default;
	  }
	});
	
	var _LivejournalShareButton = __webpack_require__(2364);
	
	Object.defineProperty(exports, 'LivejournalShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LivejournalShareButton).default;
	  }
	});
	
	var _MailruShareButton = __webpack_require__(2366);
	
	Object.defineProperty(exports, 'MailruShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MailruShareButton).default;
	  }
	});
	
	var _ViberShareButton = __webpack_require__(2387);
	
	Object.defineProperty(exports, 'ViberShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ViberShareButton).default;
	  }
	});
	
	var _WorkplaceShareButton = __webpack_require__(2392);
	
	Object.defineProperty(exports, 'WorkplaceShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WorkplaceShareButton).default;
	  }
	});
	
	var _LineShareButton = __webpack_require__(2359);
	
	Object.defineProperty(exports, 'LineShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LineShareButton).default;
	  }
	});
	
	var _WeiboShareButton = __webpack_require__(2388);
	
	Object.defineProperty(exports, 'WeiboShareButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WeiboShareButton).default;
	  }
	});
	
	var _FacebookIcon = __webpack_require__(2352);
	
	Object.defineProperty(exports, 'FacebookIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FacebookIcon).default;
	  }
	});
	
	var _TwitterIcon = __webpack_require__(2381);
	
	Object.defineProperty(exports, 'TwitterIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TwitterIcon).default;
	  }
	});
	
	var _GooglePlusIcon = __webpack_require__(2355);
	
	Object.defineProperty(exports, 'GooglePlusIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GooglePlusIcon).default;
	  }
	});
	
	var _LinkedinIcon = __webpack_require__(2360);
	
	Object.defineProperty(exports, 'LinkedinIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LinkedinIcon).default;
	  }
	});
	
	var _PinterestIcon = __webpack_require__(2370);
	
	Object.defineProperty(exports, 'PinterestIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PinterestIcon).default;
	  }
	});
	
	var _VKIcon = __webpack_require__(2383);
	
	Object.defineProperty(exports, 'VKIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_VKIcon).default;
	  }
	});
	
	var _OKIcon = __webpack_require__(2367);
	
	Object.defineProperty(exports, 'OKIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OKIcon).default;
	  }
	});
	
	var _TelegramIcon = __webpack_require__(2376);
	
	Object.defineProperty(exports, 'TelegramIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TelegramIcon).default;
	  }
	});
	
	var _WhatsappIcon = __webpack_require__(2389);
	
	Object.defineProperty(exports, 'WhatsappIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WhatsappIcon).default;
	  }
	});
	
	var _RedditIcon = __webpack_require__(2373);
	
	Object.defineProperty(exports, 'RedditIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RedditIcon).default;
	  }
	});
	
	var _TumblrIcon = __webpack_require__(2378);
	
	Object.defineProperty(exports, 'TumblrIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TumblrIcon).default;
	  }
	});
	
	var _MailruIcon = __webpack_require__(2365);
	
	Object.defineProperty(exports, 'MailruIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MailruIcon).default;
	  }
	});
	
	var _EmailIcon = __webpack_require__(2350);
	
	Object.defineProperty(exports, 'EmailIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EmailIcon).default;
	  }
	});
	
	var _LivejournalIcon = __webpack_require__(2363);
	
	Object.defineProperty(exports, 'LivejournalIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LivejournalIcon).default;
	  }
	});
	
	var _ViberIcon = __webpack_require__(2386);
	
	Object.defineProperty(exports, 'ViberIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ViberIcon).default;
	  }
	});
	
	var _WorkplaceIcon = __webpack_require__(2391);
	
	Object.defineProperty(exports, 'WorkplaceIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_WorkplaceIcon).default;
	  }
	});
	
	var _LineIcon = __webpack_require__(2358);
	
	Object.defineProperty(exports, 'LineIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_LineIcon).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(240);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(238);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(70);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(239);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(86);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(85);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _keys = __webpack_require__(697);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(698);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ieDetection = __webpack_require__(1065);
	
	var _ieDetection2 = _interopRequireDefault(_ieDetection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isPromise = function isPromise(obj) {
	  return !!obj && ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	};
	
	function windowOpen(url, _ref, onShareWindowClose) {
	  var name = _ref.name,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 400 : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? 550 : _ref$width;
	
	  /* eslint-disable no-mixed-operators */
	  var left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
	  var top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;
	  /* eslint-enable no-mixed-operators */
	
	  var config = {
	    height: height,
	    width: width,
	    left: left,
	    top: top,
	    location: 'no',
	    toolbar: 'no',
	    status: 'no',
	    directories: 'no',
	    menubar: 'no',
	    scrollbars: 'yes',
	    resizable: 'no',
	    centerscreen: 'yes',
	    chrome: 'yes'
	  };
	
	  var shareDialog = window.open(url, (0, _ieDetection2.default)(10) ? '' : name, (0, _keys2.default)(config).map(function (key) {
	    return key + '=' + config[key];
	  }).join(', '));
	
	  if (onShareWindowClose) {
	    var interval = window.setInterval(function () {
	      try {
	        if (shareDialog === null || shareDialog.closed) {
	          window.clearInterval(interval);
	          onShareWindowClose(shareDialog);
	        }
	      } catch (e) {
	        /* eslint-disable no-console */
	        console.error(e);
	        /* eslint-enable no-console */
	      }
	    }, 1000);
	  }
	
	  return shareDialog;
	}
	
	var ShareButton = function (_PureComponent) {
	  (0, _inherits3.default)(ShareButton, _PureComponent);
	
	  function ShareButton() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ShareButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = ShareButton.__proto__ || (0, _getPrototypeOf2.default)(ShareButton)).call.apply(_ref2, [this].concat(args))), _this), _this.onClick = function (e) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onClick = _this$props.onClick,
	          openWindow = _this$props.openWindow,
	          beforeOnClick = _this$props.beforeOnClick;
	
	
	      if (disabled) {
	        return;
	      }
	
	      e.preventDefault();
	
	      var link = _this.link();
	
	      var clickHandler = openWindow ? function () {
	        return _this.openWindow(link);
	      } : function () {
	        return onClick(link);
	      };
	
	      if (beforeOnClick) {
	        var returnVal = beforeOnClick();
	
	        if (isPromise(returnVal)) {
	          returnVal.then(clickHandler);
	        } else {
	          clickHandler();
	        }
	      } else {
	        clickHandler();
	      }
	    }, _this.onKeyPress = function (e) {
	      if (e.key === 'Enter' || e.key === 13 || e.key === ' ' || e.key === 32) {
	        _this.onClick(e);
	      }
	    }, _this.openWindow = function (link) {
	      var _this$props2 = _this.props,
	          onShareWindowClose = _this$props2.onShareWindowClose,
	          windowWidth = _this$props2.windowWidth,
	          windowHeight = _this$props2.windowHeight;
	
	
	      var windowOptions = {
	        height: windowHeight,
	        width: windowWidth
	      };
	
	      windowOpen(link, windowOptions, onShareWindowClose);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ShareButton, [{
	    key: 'link',
	    value: function link() {
	      var _props = this.props,
	          url = _props.url,
	          opts = _props.opts,
	          networkLink = _props.networkLink;
	
	      return networkLink(url, opts);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          additionalProps = _props2.additionalProps,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          disabledStyle = _props2.disabledStyle,
	          name = _props2.name,
	          network = _props2.network,
	          role = _props2.role,
	          style = _props2.style,
	          tabIndex = _props2.tabIndex;
	
	
	      var classes = (0, _classnames2.default)('SocialMediaShareButton', 'SocialMediaShareButton--' + network, {
	        'SocialMediaShareButton--disabled': !!disabled,
	        disabled: !!disabled
	      }, className);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({
	          name: name
	        }, additionalProps, {
	          role: role,
	          tabIndex: tabIndex,
	          onClick: this.onClick,
	          onKeyPress: this.onKeyPress,
	          className: classes,
	          style: (0, _extends3.default)({}, style, disabled ? disabledStyle : {}) }),
	        children
	      );
	    }
	  }]);
	  return ShareButton;
	}(_react.PureComponent);
	
	ShareButton.propTypes = {
	  additionalProps: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  disabledStyle: _propTypes2.default.object,
	  name: _propTypes2.default.string,
	  network: _propTypes2.default.string.isRequired,
	  networkLink: _propTypes2.default.func.isRequired,
	  onClick: _propTypes2.default.func,
	  opts: _propTypes2.default.object,
	  openWindow: _propTypes2.default.bool,
	  url: _propTypes2.default.string.isRequired,
	  role: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  windowWidth: _propTypes2.default.number,
	  windowHeight: _propTypes2.default.number,
	  beforeOnClick: _propTypes2.default.func,
	  onShareWindowClose: _propTypes2.default.func,
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	ShareButton.defaultProps = {
	  disabledStyle: {
	    opacity: 0.6
	  },
	  openWindow: true,
	  role: 'button',
	  tabIndex: '0'
	};
	
	
	function createShareButton(network, link) {
	  var optsMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
	    return {};
	  };
	  var propTypes = arguments[3];
	  var defaultProps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	  var CreatedButton = function CreatedButton(props) {
	    return _react2.default.createElement(ShareButton, (0, _extends3.default)({}, props, {
	      network: network,
	      networkLink: link,
	      opts: optsMap(props) }));
	  };
	
	  CreatedButton.propTypes = propTypes;
	  CreatedButton.defaultProps = defaultProps;
	
	  return CreatedButton;
	}
	
	exports.default = createShareButton;

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = iconFactory;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function iconFactory(network, iconConfig) {
	  var Icon = function Icon(props) {
	    var className = props.className,
	        iconBgStyle = props.iconBgStyle,
	        logoFillColor = props.logoFillColor,
	        round = props.round,
	        size = props.size;
	
	
	    var baseStyle = {
	      width: size,
	      height: size
	    };
	
	    var classes = 'social-icon social-icon--' + network + ' ' + className;
	
	    return _react2.default.createElement(
	      'div',
	      { style: baseStyle },
	      _react2.default.createElement(
	        'svg',
	        {
	          viewBox: '0 0 64 64',
	          width: size,
	          height: size,
	          className: classes },
	        _react2.default.createElement(
	          'g',
	          null,
	          !round ? _react2.default.createElement('rect', {
	            width: '64',
	            height: '64',
	            fill: iconConfig.color,
	            style: iconBgStyle }) : _react2.default.createElement('circle', {
	            cx: '32',
	            cy: '32',
	            r: '31',
	            fill: iconConfig.color,
	            style: iconBgStyle })
	        ),
	        _react2.default.createElement(
	          'g',
	          null,
	          _react2.default.createElement('path', { d: iconConfig.icon, fill: logoFillColor })
	        )
	      )
	    );
	  };
	
	  Icon.propTypes = {
	    className: _propTypes2.default.string,
	    iconBgStyle: _propTypes2.default.object,
	    logoFillColor: _propTypes2.default.string,
	    round: _propTypes2.default.bool,
	    size: _propTypes2.default.number
	  };
	
	  Icon.defaultProps = {
	    className: '',
	    iconBgStyle: {},
	    logoFillColor: 'white',
	    size: 64
	  };
	
	  return Icon;
	}

/***/ }),

/***/ 1065:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isInternetExplorerBefore;
	/*
	 * This detection method identifies Internet Explorers up until version 11.
	 *
	 * Reference: https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
	 */
	function isInternetExplorerBefore(version) {
	  var iematch = /MSIE ([0-9]+)/g.exec(window.navigator.userAgent);
	
	  return iematch ? +iematch[1] < version : false;
	}

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(697);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = objectToGetParams;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-template */
	function objectToGetParams(object) {
	  return '?' + (0, _keys2.default)(object).filter(function (key) {
	    return !!object[key];
	  }).map(function (key) {
	    return key + '=' + encodeURIComponent(object[key]);
	  }).join('&');
	}
	/* eslint-enable prefer-template */

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(240);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(238);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(70);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(239);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(86);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(85);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = shareCountFactory;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(19);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialMediaShareCount = function (_Component) {
	  (0, _inherits3.default)(SocialMediaShareCount, _Component);
	
	  function SocialMediaShareCount(props) {
	    (0, _classCallCheck3.default)(this, SocialMediaShareCount);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SocialMediaShareCount.__proto__ || (0, _getPrototypeOf2.default)(SocialMediaShareCount)).call(this, props));
	
	    _this._isMounted = false;
	    _this.state = { count: 0 };
	    return _this;
	  }
	
	  (0, _createClass3.default)(SocialMediaShareCount, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._isMounted = true;
	      this.updateCount(this.props.url);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.url !== this.props.url) {
	        this.updateCount(nextProps.url);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	    }
	  }, {
	    key: 'updateCount',
	    value: function updateCount(url) {
	      var _this2 = this;
	
	      if (this.props.getCount) {
	        this.setState({
	          isLoading: true
	        });
	
	        this.props.getCount(url, function (count) {
	          if (_this2._isMounted) {
	            _this2.setState({
	              count: count,
	              isLoading: false
	            });
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          count = _state.count,
	          isLoading = _state.isLoading;
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('SocialMediaShareCount', className) },
	        !isLoading && children(count || 0)
	      );
	    }
	  }]);
	  return SocialMediaShareCount;
	}(_react.Component);
	
	SocialMediaShareCount.propTypes = {
	  children: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  getCount: _propTypes2.default.func,
	  url: _propTypes2.default.string.isRequired
	};
	
	SocialMediaShareCount.defaultProps = {
	  children: function children(shareCount) {
	    return shareCount;
	  }
	};
	
	function shareCountFactory(getCount) {
	  return function (props) {
	    return _react2.default.createElement(SocialMediaShareCount, (0, _extends3.default)({ getCount: getCount }, props));
	  };
	}

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* Dependencies. */
	var has = __webpack_require__(263);
	var toH = __webpack_require__(311);
	var tableCellStyle = __webpack_require__(180);
	
	/* Expose `rehype-react`. */
	module.exports = rehype2react;
	
	/**
	 * Attach a react compiler.
	 *
	 * @param {Unified} processor - Instance.
	 * @param {Object?} [options]
	 * @param {Object?} [options.components]
	 *   - Components.
	 * @param {string?} [options.prefix]
	 *   - Key prefix.
	 * @param {Function?} [options.createElement]
	 *   - `h()`.
	 */
	function rehype2react(options) {
	  var settings = options || {};
	  var createElement = settings.createElement;
	  var components = settings.components || {};
	
	  this.Compiler = compiler;
	
	  /* Compile HAST to React. */
	  function compiler(node) {
	    if (node.type === 'root') {
	      if (node.children.length === 1 && node.children[0].type === 'element') {
	        node = node.children[0];
	      } else {
	        node = {
	          type: 'element',
	          tagName: 'div',
	          properties: node.properties || {},
	          children: node.children
	        };
	      }
	    }
	
	    return toH(h, tableCellStyle(node), settings.prefix);
	  }
	
	  /* Wrap `createElement` to pass components in. */
	  function h(name, props, children) {
	    var component = has(components, name) ? components[name] : name;
	    return createElement(component, props, children);
	  }
	}


/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var html = __webpack_require__(313)
	var svg = __webpack_require__(316)
	var find = __webpack_require__(312)
	var spaces = __webpack_require__(317)
	var commas = __webpack_require__(241)
	var style = __webpack_require__(318)
	var ns = __webpack_require__(269)
	var is = __webpack_require__(319)
	
	var dashes = /-([a-z])/g
	
	module.exports = wrapper
	
	function wrapper(h, node, options) {
	  var settings = options || {}
	  var prefix
	  var r
	  var v
	
	  if (typeof h !== 'function') {
	    throw new Error('h is not a function')
	  }
	
	  if (typeof settings === 'string' || typeof settings === 'boolean') {
	    prefix = settings
	    settings = {}
	  } else {
	    prefix = settings.prefix
	  }
	
	  r = react(h)
	  v = vdom(h)
	
	  if (prefix === null || prefix === undefined) {
	    prefix = r === true || v === true ? 'h-' : false
	  }
	
	  if (is('root', node)) {
	    if (node.children.length === 1 && is('element', node.children[0])) {
	      node = node.children[0]
	    } else {
	      node = {
	        type: 'element',
	        tagName: 'div',
	        properties: {},
	        children: node.children
	      }
	    }
	  } else if (!is('element', node)) {
	    throw new Error(
	      'Expected root or element, not `' + ((node && node.type) || node) + '`'
	    )
	  }
	
	  return toH(h, node, {
	    schema: settings.space === 'svg' ? svg : html,
	    prefix: prefix,
	    key: 0,
	    react: r,
	    vdom: v,
	    hyperscript: hyperscript(h)
	  })
	}
	
	// Transform a HAST node through a hyperscript interface
	// to *anything*!
	function toH(h, node, ctx) {
	  var parentSchema = ctx.schema
	  var schema = parentSchema
	  var name = node.tagName
	  var properties
	  var attributes
	  var children
	  var property
	  var elements
	  var length
	  var index
	  var value
	  var result
	
	  if (parentSchema.space === 'html' && name.toLowerCase() === 'svg') {
	    schema = svg
	    ctx.schema = schema
	  }
	
	  if (ctx.vdom === true && schema.space === 'html') {
	    name = name.toUpperCase()
	  }
	
	  properties = node.properties
	  attributes = {}
	
	  for (property in properties) {
	    addAttribute(attributes, property, properties[property], ctx)
	  }
	
	  if (
	    typeof attributes.style === 'string' &&
	    (ctx.vdom === true || ctx.react === true)
	  ) {
	    // VDOM and React accept `style` as object.
	    attributes.style = parseStyle(attributes.style, name)
	  }
	
	  if (ctx.prefix) {
	    ctx.key++
	    attributes.key = ctx.prefix + ctx.key
	  }
	
	  if (ctx.vdom && schema.space !== 'html') {
	    attributes.namespace = ns[schema.space]
	  }
	
	  elements = []
	  children = node.children
	  length = children ? children.length : 0
	  index = -1
	
	  while (++index < length) {
	    value = children[index]
	
	    if (is('element', value)) {
	      elements.push(toH(h, value, ctx))
	    } else if (is('text', value)) {
	      elements.push(value.value)
	    }
	  }
	
	  // Ensure no React warnings are triggered for
	  // void elements having children passed in.
	  result =
	    elements.length === 0 ? h(name, attributes) : h(name, attributes, elements)
	
	  // Restore parent schema.
	  ctx.schema = parentSchema
	
	  return result
	}
	
	function addAttribute(props, prop, value, ctx) {
	  var schema = ctx.schema
	  var info = find(schema, prop)
	  var subprop
	
	  // Ignore nully, `false`, `NaN`, and falsey known booleans.
	  if (
	    value === null ||
	    value === undefined ||
	    value === false ||
	    value !== value ||
	    (info.boolean && !value)
	  ) {
	    return
	  }
	
	  if (value !== null && typeof value === 'object' && 'length' in value) {
	    // Accept `array`.  Most props are space-separater.
	    value = (info.commaSeparated ? commas : spaces).stringify(value)
	  }
	
	  // Treat `true` and truthy known booleans.
	  if (info.boolean && ctx.hyperscript === true) {
	    value = ''
	  }
	
	  if (!info.mustUseProperty) {
	    if (ctx.vdom === true) {
	      subprop = 'attributes'
	    } else if (ctx.hyperscript === true) {
	      subprop = 'attrs'
	    }
	  }
	
	  if (subprop) {
	    if (props[subprop] === undefined) {
	      props[subprop] = {}
	    }
	
	    props[subprop][info.attribute] = value
	  } else {
	    props[ctx.react && info.space ? info.property : info.attribute] = value
	  }
	}
	
	// Check if `h` is `react.createElement`.
	function react(h) {
	  var node = h && h('div')
	  return Boolean(
	    node && ('_owner' in node || '_store' in node) && node.key === null
	  )
	}
	
	// Check if `h` is `hyperscript`.
	function hyperscript(h) {
	  return Boolean(h && h.context && h.cleanup)
	}
	
	// Check if `h` is `virtual-dom/h`.
	function vdom(h) {
	  return h && h('div').type === 'VirtualNode'
	}
	
	function parseStyle(value, tagName) {
	  var result = {}
	
	  try {
	    style(value, iterator)
	  } catch (err) {
	    err.message = tagName + '[style]' + err.message.slice('undefined'.length)
	    throw err
	  }
	
	  return result
	
	  function iterator(name, value) {
	    result[styleCase(name)] = value
	  }
	}
	
	function styleCase(val) {
	  if (val.slice(0, 4) === '-ms-') {
	    val = 'ms-' + val.slice(4)
	  }
	
	  return val.replace(dashes, styleReplacer)
	}
	
	function styleReplacer($0, $1) {
	  return $1.toUpperCase()
	}


/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var normalize = __webpack_require__(112)
	var DefinedInfo = __webpack_require__(105)
	var Info = __webpack_require__(106)
	
	var data = 'data'
	
	module.exports = find
	
	var valid = /^data[-a-z0-9.:_]+$/i
	var dash = /-[a-z]/g
	var cap = /[A-Z]/g
	
	function find(schema, value) {
	  var normal = normalize(value)
	  var prop = value
	  var Type = Info
	
	  if (normal in schema.normal) {
	    return schema.property[schema.normal[normal]]
	  }
	
	  if (normal.length > 4 && normal.slice(0, 4) === data && valid.test(value)) {
	    // Attribute or property.
	    if (value.charAt(4) === '-') {
	      prop = datasetToProperty(value)
	    } else {
	      value = datasetToAttribute(value)
	    }
	
	    Type = DefinedInfo
	  }
	
	  return new Type(prop, value)
	}
	
	function datasetToProperty(attribute) {
	  var value = attribute.slice(5).replace(dash, camelcase)
	  return data + value.charAt(0).toUpperCase() + value.slice(1)
	}
	
	function datasetToAttribute(property) {
	  var value = property.slice(4)
	
	  if (dash.test(value)) {
	    return property
	  }
	
	  value = value.replace(cap, kebab)
	
	  if (value.charAt(0) !== '-') {
	    value = '-' + value
	  }
	
	  return data + value
	}
	
	function kebab($0) {
	  return '-' + $0.toLowerCase()
	}
	
	function camelcase($0) {
	  return $0.charAt(1).toUpperCase()
	}


/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var merge = __webpack_require__(107)
	var xlink = __webpack_require__(109)
	var xml = __webpack_require__(110)
	var xmlns = __webpack_require__(111)
	var aria = __webpack_require__(102)
	var html = __webpack_require__(314)
	
	module.exports = merge([xml, xlink, xmlns, aria, html])


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var types = __webpack_require__(52)
	var create = __webpack_require__(34)
	
	var booleanish = types.booleanish
	var number = types.number
	var spaceSeparated = types.spaceSeparated
	
	module.exports = create({
	  transform: ariaTransform,
	  properties: {
	    ariaActiveDescendant: null,
	    ariaAtomic: booleanish,
	    ariaAutoComplete: null,
	    ariaBusy: booleanish,
	    ariaChecked: booleanish,
	    ariaColCount: number,
	    ariaColIndex: number,
	    ariaColSpan: number,
	    ariaControls: spaceSeparated,
	    ariaCurrent: null,
	    ariaDescribedBy: spaceSeparated,
	    ariaDetails: null,
	    ariaDisabled: booleanish,
	    ariaDropEffect: spaceSeparated,
	    ariaErrorMessage: null,
	    ariaExpanded: booleanish,
	    ariaFlowTo: spaceSeparated,
	    ariaGrabbed: booleanish,
	    ariaHasPopup: null,
	    ariaHidden: booleanish,
	    ariaInvalid: null,
	    ariaKeyShortcuts: null,
	    ariaLabel: null,
	    ariaLabelledBy: spaceSeparated,
	    ariaLevel: number,
	    ariaLive: null,
	    ariaModal: booleanish,
	    ariaMultiLine: booleanish,
	    ariaMultiSelectable: booleanish,
	    ariaOrientation: null,
	    ariaOwns: spaceSeparated,
	    ariaPlaceholder: null,
	    ariaPosInSet: number,
	    ariaPressed: booleanish,
	    ariaReadOnly: booleanish,
	    ariaRelevant: null,
	    ariaRequired: booleanish,
	    ariaRoleDescription: spaceSeparated,
	    ariaRowCount: number,
	    ariaRowIndex: number,
	    ariaRowSpan: number,
	    ariaSelected: booleanish,
	    ariaSetSize: number,
	    ariaSort: null,
	    ariaValueMax: number,
	    ariaValueMin: number,
	    ariaValueNow: number,
	    ariaValueText: null,
	    role: null
	  }
	})
	
	function ariaTransform(_, prop) {
	  return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
	}


/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var types = __webpack_require__(52)
	var create = __webpack_require__(34)
	var caseInsensitiveTransform = __webpack_require__(103)
	
	var boolean = types.boolean
	var overloadedBoolean = types.overloadedBoolean
	var booleanish = types.booleanish
	var number = types.number
	var spaceSeparated = types.spaceSeparated
	var commaSeparated = types.commaSeparated
	
	module.exports = create({
	  space: 'html',
	  attributes: {
	    acceptcharset: 'accept-charset',
	    classname: 'class',
	    htmlfor: 'for',
	    httpequiv: 'http-equiv'
	  },
	  transform: caseInsensitiveTransform,
	  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
	  properties: {
	    // Standard Properties.
	    abbr: null,
	    accept: commaSeparated,
	    acceptCharset: spaceSeparated,
	    accessKey: spaceSeparated,
	    action: null,
	    allowFullScreen: boolean,
	    allowPaymentRequest: boolean,
	    allowUserMedia: boolean,
	    alt: null,
	    as: null,
	    async: boolean,
	    autoCapitalize: null,
	    autoComplete: spaceSeparated,
	    autoFocus: boolean,
	    autoPlay: boolean,
	    capture: boolean,
	    charSet: null,
	    checked: boolean,
	    cite: null,
	    className: spaceSeparated,
	    cols: number,
	    colSpan: null,
	    content: null,
	    contentEditable: booleanish,
	    controls: boolean,
	    controlsList: spaceSeparated,
	    coords: number | commaSeparated,
	    crossOrigin: null,
	    data: null,
	    dateTime: null,
	    decoding: null,
	    default: boolean,
	    defer: boolean,
	    dir: null,
	    dirName: null,
	    disabled: boolean,
	    download: overloadedBoolean,
	    draggable: booleanish,
	    encType: null,
	    form: null,
	    formAction: null,
	    formEncType: null,
	    formMethod: null,
	    formNoValidate: boolean,
	    formTarget: null,
	    headers: spaceSeparated,
	    height: number,
	    hidden: boolean,
	    high: number,
	    href: null,
	    hrefLang: null,
	    htmlFor: spaceSeparated,
	    httpEquiv: spaceSeparated,
	    id: null,
	    inputMode: null,
	    integrity: null,
	    is: null,
	    isMap: boolean,
	    itemId: null,
	    itemProp: spaceSeparated,
	    itemRef: spaceSeparated,
	    itemScope: boolean,
	    itemType: spaceSeparated,
	    kind: null,
	    label: null,
	    lang: null,
	    language: null,
	    list: null,
	    loop: boolean,
	    low: number,
	    manifest: null,
	    max: null,
	    maxLength: number,
	    media: null,
	    method: null,
	    min: null,
	    minLength: number,
	    multiple: boolean,
	    muted: boolean,
	    name: null,
	    nonce: null,
	    noModule: boolean,
	    noValidate: boolean,
	    open: boolean,
	    optimum: number,
	    pattern: null,
	    ping: spaceSeparated,
	    placeholder: null,
	    playsInline: boolean,
	    poster: null,
	    preload: null,
	    readOnly: boolean,
	    referrerPolicy: null,
	    rel: spaceSeparated,
	    required: boolean,
	    reversed: boolean,
	    rows: number,
	    rowSpan: number,
	    sandbox: spaceSeparated,
	    scope: null,
	    scoped: boolean,
	    seamless: boolean,
	    selected: boolean,
	    shape: null,
	    size: number,
	    sizes: spaceSeparated,
	    slot: null,
	    span: number,
	    spellCheck: booleanish,
	    src: null,
	    srcDoc: null,
	    srcLang: null,
	    srcSet: commaSeparated,
	    start: number,
	    step: null,
	    style: null,
	    tabIndex: number,
	    target: null,
	    title: null,
	    translate: null,
	    type: null,
	    typeMustMatch: boolean,
	    useMap: null,
	    value: booleanish,
	    width: number,
	    wrap: null,
	
	    // Legacy.
	    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
	    align: null, // Several. Use CSS `text-align` instead,
	    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
	    archive: spaceSeparated, // `<object>`. List of URIs to archives
	    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
	    background: null, // `<body>`. Use CSS `background-image` instead
	    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
	    border: number, // `<table>`. Use CSS `border-width` instead,
	    borderColor: null, // `<table>`. Use CSS `border-color` instead,
	    bottomMargin: number, // `<body>`
	    cellPadding: null, // `<table>`
	    cellSpacing: null, // `<table>`
	    char: null, // Several table elements. When `align=char`, sets the character to align on
	    charOff: null, // Several table elements. When `char`, offsets the alignment
	    classId: null, // `<object>`
	    clear: null, // `<br>`. Use CSS `clear` instead
	    code: null, // `<object>`
	    codeBase: null, // `<object>`
	    codeType: null, // `<object>`
	    color: null, // `<font>` and `<hr>`. Use CSS instead
	    compact: boolean, // Lists. Use CSS to reduce space between items instead
	    declare: boolean, // `<object>`
	    event: null, // `<script>`
	    face: null, // `<font>`. Use CSS instead
	    frame: null, // `<table>`
	    frameBorder: null, // `<iframe>`. Use CSS `border` instead
	    hSpace: number, // `<img>` and `<object>`
	    leftMargin: number, // `<body>`
	    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
	    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
	    lowSrc: null, // `<img>`. Use a `<picture>`
	    marginHeight: number, // `<body>`
	    marginWidth: number, // `<body>`
	    noResize: boolean, // `<frame>`
	    noHref: boolean, // `<area>`. Use no href instead of an explicit `nohref`
	    noShade: boolean, // `<hr>`. Use background-color and height instead of borders
	    noWrap: boolean, // `<td>` and `<th>`
	    object: null, // `<applet>`
	    profile: null, // `<head>`
	    prompt: null, // `<isindex>`
	    rev: null, // `<link>`
	    rightMargin: number, // `<body>`
	    rules: null, // `<table>`
	    scheme: null, // `<meta>`
	    scrolling: booleanish, // `<frame>`. Use overflow in the child context
	    standby: null, // `<object>`
	    summary: null, // `<table>`
	    text: null, // `<body>`. Use CSS `color` instead
	    topMargin: number, // `<body>`
	    valueType: null, // `<param>`
	    version: null, // `<html>`. Use a doctype.
	    vAlign: null, // Several. Use CSS `vertical-align` instead
	    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
	    vSpace: number, // `<img>` and `<object>`
	
	    // Non-standard Properties.
	    allowTransparency: null,
	    autoCorrect: null,
	    autoSave: null,
	    prefix: null,
	    property: null,
	    results: number,
	    security: null,
	    unselectable: null
	  }
	})


/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var types = __webpack_require__(52)
	var create = __webpack_require__(34)
	var caseSensitiveTransform = __webpack_require__(104)
	
	var boolean = types.boolean
	var number = types.number
	var spaceSeparated = types.spaceSeparated
	var commaSeparated = types.commaSeparated
	var commaOrSpaceSeparated = types.commaOrSpaceSeparated
	
	module.exports = create({
	  space: 'svg',
	  attributes: {
	    accentHeight: 'accent-height',
	    alignmentBaseline: 'alignment-baseline',
	    arabicForm: 'arabic-form',
	    baselineShift: 'baseline-shift',
	    capHeight: 'cap-height',
	    className: 'class',
	    clipPath: 'clip-path',
	    clipRule: 'clip-rule',
	    colorInterpolation: 'color-interpolation',
	    colorInterpolationFilters: 'color-interpolation-filters',
	    colorProfile: 'color-profile',
	    colorRendering: 'color-rendering',
	    crossOrigin: 'crossorigin',
	    dataType: 'datatype',
	    dominantBaseline: 'dominant-baseline',
	    enableBackground: 'enable-background',
	    fillOpacity: 'fill-opacity',
	    fillRule: 'fill-rule',
	    floodColor: 'flood-color',
	    floodOpacity: 'flood-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    fontSizeAdjust: 'font-size-adjust',
	    fontStretch: 'font-stretch',
	    fontStyle: 'font-style',
	    fontVariant: 'font-variant',
	    fontWeight: 'font-weight',
	    glyphName: 'glyph-name',
	    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	    glyphOrientationVertical: 'glyph-orientation-vertical',
	    hrefLang: 'hreflang',
	    horizAdvX: 'horiz-adv-x',
	    horizOriginX: 'horiz-origin-x',
	    horizOriginY: 'horiz-origin-y',
	    imageRendering: 'image-rendering',
	    letterSpacing: 'letter-spacing',
	    lightingColor: 'lighting-color',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    navDown: 'nav-down',
	    navDownLeft: 'nav-down-left',
	    navDownRight: 'nav-down-right',
	    navLeft: 'nav-left',
	    navNext: 'nav-next',
	    navPrev: 'nav-prev',
	    navRight: 'nav-right',
	    navUp: 'nav-up',
	    navUpLeft: 'nav-up-left',
	    navUpRight: 'nav-up-right',
	    overlinePosition: 'overline-position',
	    overlineThickness: 'overline-thickness',
	    paintOrder: 'paint-order',
	    panose1: 'panose-1',
	    pointerEvents: 'pointer-events',
	    renderingIntent: 'rendering-intent',
	    shapeRendering: 'shape-rendering',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strikethroughPosition: 'strikethrough-position',
	    strikethroughThickness: 'strikethrough-thickness',
	    strokeDashArray: 'stroke-dasharray',
	    strokeDashOffset: 'stroke-dashoffset',
	    strokeLineCap: 'stroke-linecap',
	    strokeLineJoin: 'stroke-linejoin',
	    strokeMiterLimit: 'stroke-miterlimit',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    tabIndex: 'tabindex',
	    textAnchor: 'text-anchor',
	    textDecoration: 'text-decoration',
	    textRendering: 'text-rendering',
	    typeOf: 'typeof',
	    underlinePosition: 'underline-position',
	    underlineThickness: 'underline-thickness',
	    unicodeBidi: 'unicode-bidi',
	    unicodeRange: 'unicode-range',
	    unitsPerEm: 'units-per-em',
	    vAlphabetic: 'v-alphabetic',
	    vHanging: 'v-hanging',
	    vIdeographic: 'v-ideographic',
	    vMathematical: 'v-mathematical',
	    vectorEffect: 'vector-effect',
	    vertAdvY: 'vert-adv-y',
	    vertOriginX: 'vert-origin-x',
	    vertOriginY: 'vert-origin-y',
	    wordSpacing: 'word-spacing',
	    writingMode: 'writing-mode',
	    xHeight: 'x-height',
	    // These were camelcased in Tiny. Now lowercased in SVG 2
	    playbackOrder: 'playbackorder',
	    timelineBegin: 'timelinebegin'
	  },
	  transform: caseSensitiveTransform,
	  properties: {
	    about: commaOrSpaceSeparated,
	    accentHeight: number,
	    accumulate: null,
	    additive: null,
	    alignmentBaseline: null,
	    alphabetic: number,
	    amplitude: number,
	    arabicForm: null,
	    ascent: number,
	    attributeName: null,
	    attributeType: null,
	    azimuth: number,
	    bandwidth: null,
	    baselineShift: null,
	    baseFrequency: null,
	    baseProfile: null,
	    bbox: null,
	    begin: null,
	    bias: number,
	    by: null,
	    calcMode: null,
	    capHeight: number,
	    className: spaceSeparated,
	    clip: null,
	    clipPath: null,
	    clipPathUnits: null,
	    clipRule: null,
	    color: null,
	    colorInterpolation: null,
	    colorInterpolationFilters: null,
	    colorProfile: null,
	    colorRendering: null,
	    content: null,
	    contentScriptType: null,
	    contentStyleType: null,
	    crossOrigin: null,
	    cursor: null,
	    cx: null,
	    cy: null,
	    d: null,
	    dataType: null,
	    defaultAction: null,
	    descent: number,
	    diffuseConstant: number,
	    direction: null,
	    display: null,
	    dur: null,
	    divisor: number,
	    dominantBaseline: null,
	    download: boolean,
	    dx: null,
	    dy: null,
	    edgeMode: null,
	    editable: null,
	    elevation: number,
	    enableBackground: null,
	    end: null,
	    event: null,
	    exponent: number,
	    externalResourcesRequired: null,
	    fill: null,
	    fillOpacity: number,
	    fillRule: null,
	    filter: null,
	    filterRes: null,
	    filterUnits: null,
	    floodColor: null,
	    floodOpacity: null,
	    focusable: null,
	    focusHighlight: null,
	    fontFamily: null,
	    fontSize: null,
	    fontSizeAdjust: null,
	    fontStretch: null,
	    fontStyle: null,
	    fontVariant: null,
	    fontWeight: null,
	    format: null,
	    fr: null,
	    from: null,
	    fx: null,
	    fy: null,
	    g1: commaSeparated,
	    g2: commaSeparated,
	    glyphName: commaSeparated,
	    glyphOrientationHorizontal: null,
	    glyphOrientationVertical: null,
	    glyphRef: null,
	    gradientTransform: null,
	    gradientUnits: null,
	    handler: null,
	    hanging: number,
	    hatchContentUnits: null,
	    hatchUnits: null,
	    height: null,
	    href: null,
	    hrefLang: null,
	    horizAdvX: number,
	    horizOriginX: number,
	    horizOriginY: number,
	    id: null,
	    ideographic: number,
	    imageRendering: null,
	    initialVisibility: null,
	    in: null,
	    in2: null,
	    intercept: number,
	    k: number,
	    k1: number,
	    k2: number,
	    k3: number,
	    k4: number,
	    kernelMatrix: commaOrSpaceSeparated,
	    kernelUnitLength: null,
	    keyPoints: null, // SEMI_COLON_SEPARATED
	    keySplines: null, // SEMI_COLON_SEPARATED
	    keyTimes: null, // SEMI_COLON_SEPARATED
	    kerning: null,
	    lang: null,
	    lengthAdjust: null,
	    letterSpacing: null,
	    lightingColor: null,
	    limitingConeAngle: number,
	    local: null,
	    markerEnd: null,
	    markerMid: null,
	    markerStart: null,
	    markerHeight: null,
	    markerUnits: null,
	    markerWidth: null,
	    mask: null,
	    maskContentUnits: null,
	    maskUnits: null,
	    mathematical: null,
	    max: null,
	    media: null,
	    mediaCharacterEncoding: null,
	    mediaContentEncodings: null,
	    mediaSize: number,
	    mediaTime: null,
	    method: null,
	    min: null,
	    mode: null,
	    name: null,
	    navDown: null,
	    navDownLeft: null,
	    navDownRight: null,
	    navLeft: null,
	    navNext: null,
	    navPrev: null,
	    navRight: null,
	    navUp: null,
	    navUpLeft: null,
	    navUpRight: null,
	    numOctaves: null,
	    observer: null,
	    offset: null,
	    opacity: null,
	    operator: null,
	    order: null,
	    orient: null,
	    orientation: null,
	    origin: null,
	    overflow: null,
	    overlay: null,
	    overlinePosition: number,
	    overlineThickness: number,
	    paintOrder: null,
	    panose1: null,
	    path: null,
	    pathLength: number,
	    patternContentUnits: null,
	    patternTransform: null,
	    patternUnits: null,
	    phase: null,
	    pitch: null,
	    playbackOrder: null,
	    pointerEvents: null,
	    points: null,
	    pointsAtX: number,
	    pointsAtY: number,
	    pointsAtZ: number,
	    preserveAlpha: null,
	    preserveAspectRatio: null,
	    primitiveUnits: null,
	    propagate: null,
	    property: commaOrSpaceSeparated,
	    r: null,
	    radius: null,
	    refX: null,
	    refY: null,
	    rel: commaOrSpaceSeparated,
	    rev: commaOrSpaceSeparated,
	    renderingIntent: null,
	    repeatCount: null,
	    repeatDur: null,
	    requiredExtensions: commaOrSpaceSeparated,
	    requiredFeatures: commaOrSpaceSeparated,
	    requiredFonts: commaOrSpaceSeparated,
	    requiredFormats: commaOrSpaceSeparated,
	    resource: null,
	    restart: null,
	    result: null,
	    rotate: null,
	    rx: null,
	    ry: null,
	    scale: null,
	    seed: null,
	    shapeRendering: null,
	    side: null,
	    slope: null,
	    snapshotTime: null,
	    specularConstant: number,
	    specularExponent: number,
	    spreadMethod: null,
	    spacing: null,
	    startOffset: null,
	    stdDeviation: null,
	    stemh: null,
	    stemv: null,
	    stitchTiles: null,
	    stopColor: null,
	    stopOpacity: null,
	    strikethroughPosition: number,
	    strikethroughThickness: number,
	    string: null,
	    stroke: null,
	    strokeDashArray: commaOrSpaceSeparated,
	    strokeDashOffset: null,
	    strokeLineCap: null,
	    strokeLineJoin: null,
	    strokeMiterLimit: number,
	    strokeOpacity: number,
	    strokeWidth: null,
	    style: null,
	    surfaceScale: number,
	    syncBehavior: null,
	    syncBehaviorDefault: null,
	    syncMaster: null,
	    syncTolerance: null,
	    syncToleranceDefault: null,
	    systemLanguage: commaOrSpaceSeparated,
	    tabIndex: number,
	    tableValues: null,
	    target: null,
	    targetX: number,
	    targetY: number,
	    textAnchor: null,
	    textDecoration: null,
	    textRendering: null,
	    textLength: null,
	    timelineBegin: null,
	    title: null,
	    transformBehavior: null,
	    type: null,
	    typeOf: commaOrSpaceSeparated,
	    to: null,
	    transform: null,
	    u1: null,
	    u2: null,
	    underlinePosition: number,
	    underlineThickness: number,
	    unicode: null,
	    unicodeBidi: null,
	    unicodeRange: null,
	    unitsPerEm: number,
	    values: null,
	    vAlphabetic: number,
	    vMathematical: number,
	    vectorEffect: null,
	    vHanging: number,
	    vIdeographic: number,
	    version: null,
	    vertAdvY: number,
	    vertOriginX: number,
	    vertOriginY: number,
	    viewBox: null,
	    viewTarget: null,
	    visibility: null,
	    width: null,
	    widths: null,
	    wordSpacing: null,
	    writingMode: null,
	    x: null,
	    x1: null,
	    x2: null,
	    xChannelSelector: null,
	    xHeight: number,
	    y: null,
	    y1: null,
	    y2: null,
	    yChannelSelector: null,
	    z: null,
	    zoomAndPan: null
	  }
	})


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var caseSensitiveTransform = __webpack_require__(104)
	
	module.exports = caseInsensitiveTransform
	
	function caseInsensitiveTransform(attributes, property) {
	  return caseSensitiveTransform(attributes, property.toLowerCase())
	}


/***/ }),

/***/ 104:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = caseSensitiveTransform
	
	function caseSensitiveTransform(attributes, attribute) {
	  return attribute in attributes ? attributes[attribute] : attribute
	}


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var normalize = __webpack_require__(112)
	var Schema = __webpack_require__(108)
	var DefinedInfo = __webpack_require__(105)
	
	module.exports = create
	
	function create(definition) {
	  var space = definition.space
	  var mustUseProperty = definition.mustUseProperty || []
	  var attributes = definition.attributes || {}
	  var props = definition.properties
	  var transform = definition.transform
	  var property = {}
	  var normal = {}
	  var prop
	  var info
	
	  for (prop in props) {
	    info = new DefinedInfo(
	      prop,
	      transform(attributes, prop),
	      props[prop],
	      space
	    )
	
	    if (mustUseProperty.indexOf(prop) !== -1) {
	      info.mustUseProperty = true
	    }
	
	    property[prop] = info
	
	    normal[normalize(prop)] = prop
	    normal[normalize(info.attribute)] = prop
	  }
	
	  return new Schema(property, normal, space)
	}


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var Info = __webpack_require__(106)
	var types = __webpack_require__(52)
	
	module.exports = DefinedInfo
	
	DefinedInfo.prototype = new Info()
	DefinedInfo.prototype.defined = true
	
	function DefinedInfo(property, attribute, mask, space) {
	  mark(this, 'space', space)
	  Info.call(this, property, attribute)
	  mark(this, 'boolean', check(mask, types.boolean))
	  mark(this, 'booleanish', check(mask, types.booleanish))
	  mark(this, 'overloadedBoolean', check(mask, types.overloadedBoolean))
	  mark(this, 'number', check(mask, types.number))
	  mark(this, 'commaSeparated', check(mask, types.commaSeparated))
	  mark(this, 'spaceSeparated', check(mask, types.spaceSeparated))
	  mark(this, 'commaOrSpaceSeparated', check(mask, types.commaOrSpaceSeparated))
	}
	
	function mark(values, key, value) {
	  if (value) {
	    values[key] = value
	  }
	}
	
	function check(value, mask) {
	  return (value & mask) === mask
	}


/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = Info
	
	var proto = Info.prototype
	
	proto.space = null
	proto.attribute = null
	proto.property = null
	proto.boolean = false
	proto.booleanish = false
	proto.overloadedBoolean = false
	proto.number = false
	proto.commaSeparated = false
	proto.spaceSeparated = false
	proto.commaOrSpaceSeparated = false
	proto.mustUseProperty = false
	proto.defined = false
	
	function Info(property, attribute) {
	  this.property = property
	  this.attribute = attribute
	}


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var xtend = __webpack_require__(455)
	var Schema = __webpack_require__(108)
	
	module.exports = merge
	
	function merge(definitions) {
	  var length = definitions.length
	  var property = []
	  var normal = []
	  var index = -1
	  var info
	  var space
	
	  while (++index < length) {
	    info = definitions[index]
	    property.push(info.property)
	    normal.push(info.normal)
	    space = info.space
	  }
	
	  return new Schema(
	    xtend.apply(null, property),
	    xtend.apply(null, normal),
	    space
	  )
	}


/***/ }),

/***/ 108:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = Schema
	
	var proto = Schema.prototype
	
	proto.space = null
	proto.normal = {}
	proto.property = {}
	
	function Schema(property, normal, space) {
	  this.property = property
	  this.normal = normal
	
	  if (space) {
	    this.space = space
	  }
	}


/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	'use strict'
	
	var powers = 0
	
	exports.boolean = increment()
	exports.booleanish = increment()
	exports.overloadedBoolean = increment()
	exports.number = increment()
	exports.spaceSeparated = increment()
	exports.commaSeparated = increment()
	exports.commaOrSpaceSeparated = increment()
	
	function increment() {
	  return Math.pow(2, ++powers)
	}


/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var create = __webpack_require__(34)
	
	module.exports = create({
	  space: 'xlink',
	  transform: xlinkTransform,
	  properties: {
	    xLinkActuate: null,
	    xLinkArcRole: null,
	    xLinkHref: null,
	    xLinkRole: null,
	    xLinkShow: null,
	    xLinkTitle: null,
	    xLinkType: null
	  }
	})
	
	function xlinkTransform(_, prop) {
	  return 'xlink:' + prop.slice(5).toLowerCase()
	}


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var create = __webpack_require__(34)
	
	module.exports = create({
	  space: 'xml',
	  transform: xmlTransform,
	  properties: {
	    xmlLang: null,
	    xmlBase: null,
	    xmlSpace: null
	  }
	})
	
	function xmlTransform(_, prop) {
	  return 'xml:' + prop.slice(3).toLowerCase()
	}


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var create = __webpack_require__(34)
	var caseInsensitiveTransform = __webpack_require__(103)
	
	module.exports = create({
	  space: 'xmlns',
	  attributes: {
	    xmlnsxlink: 'xmlns:xlink'
	  },
	  transform: caseInsensitiveTransform,
	  properties: {
	    xmlns: null,
	    xmlnsXLink: null
	  }
	})


/***/ }),

/***/ 112:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = normalize
	
	function normalize(value) {
	  return value.toLowerCase().replace(/\b[:-]\b/g, '')
	}


/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var merge = __webpack_require__(107)
	var xlink = __webpack_require__(109)
	var xml = __webpack_require__(110)
	var xmlns = __webpack_require__(111)
	var aria = __webpack_require__(102)
	var svg = __webpack_require__(315)
	
	module.exports = merge([xml, xlink, xmlns, aria, svg])


/***/ }),

/***/ 317:
/***/ (function(module, exports) {

	'use strict'
	
	exports.parse = parse
	exports.stringify = stringify
	
	var empty = ''
	var space = ' '
	var whiteSpace = /[ \t\n\r\f]+/g
	
	function parse(value) {
	  var input = String(value || empty).trim()
	  return input === empty ? [] : input.split(whiteSpace)
	}
	
	function stringify(values) {
	  return values.join(space).trim()
	}


/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(268);
	
	/**
	 * Parses inline style to object.
	 *
	 * @example
	 * // returns { 'line-height': '42' }
	 * StyleToObject('line-height: 42;');
	 *
	 * @param  {String}      style      - The inline style.
	 * @param  {Function}    [iterator] - The iterator function.
	 * @return {null|Object}
	 */
	function StyleToObject(style, iterator) {
	  var output = null;
	  if (!style || typeof style !== 'string') {
	    return output;
	  }
	
	  var declaration;
	  var declarations = parse(style);
	  var hasIterator = typeof iterator === 'function';
	  var property;
	  var value;
	
	  for (var i = 0, len = declarations.length; i < len; i++) {
	    declaration = declarations[i];
	    property = declaration.property;
	    value = declaration.value;
	
	    if (hasIterator) {
	      iterator(property, value, declaration);
	    } else if (value) {
	      output || (output = {});
	      output[property] = value;
	    }
	  }
	
	  return output;
	}
	
	module.exports = StyleToObject;


/***/ }),

/***/ 319:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = is
	
	// Assert if `test` passes for `node`.   When a `parent` node is known the
	// `index` of node.
	// eslint-disable-next-line max-params
	function is(test, node, index, parent, context) {
	  var hasParent = parent !== null && parent !== undefined
	  var hasIndex = index !== null && index !== undefined
	  var check = convert(test)
	
	  if (
	    hasIndex &&
	    (typeof index !== 'number' || index < 0 || index === Infinity)
	  ) {
	    throw new Error('Expected positive finite index or child node')
	  }
	
	  if (hasParent && (!is(null, parent) || !parent.children)) {
	    throw new Error('Expected parent node')
	  }
	
	  if (!node || !node.type || typeof node.type !== 'string') {
	    return false
	  }
	
	  if (hasParent !== hasIndex) {
	    throw new Error('Expected both parent and index')
	  }
	
	  return Boolean(check.call(context, node, index, parent))
	}
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test)
	  }
	
	  if (test === null || test === undefined) {
	    return ok
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test)
	  }
	
	  if (typeof test === 'function') {
	    return test
	  }
	
	  throw new Error('Expected function, string, or object as test')
	}
	
	function convertAll(tests) {
	  var results = []
	  var length = tests.length
	  var index = -1
	
	  while (++index < length) {
	    results[index] = convert(tests[index])
	  }
	
	  return results
	}
	
	// Utility assert each property in `test` is represented in `node`, and each
	// values are strictly equal.
	function matchesFactory(test) {
	  return matches
	
	  function matches(node) {
	    var key
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false
	      }
	    }
	
	    return true
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests)
	  var length = checks.length
	
	  return matches
	
	  function matches() {
	    var index = -1
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true
	      }
	    }
	
	    return false
	  }
	}
	
	// Utility to convert a string into a function which checks a given node’s type
	// for said string.
	function typeFactory(test) {
	  return type
	
	  function type(node) {
	    return Boolean(node && node.type === test)
	  }
	}
	
	// Utility to return true.
	function ok() {
	  return true
	}


/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visitParents
	
	var convert = __webpack_require__(321)
	
	var CONTINUE = true
	var SKIP = 'skip'
	var EXIT = false
	
	visitParents.CONTINUE = CONTINUE
	visitParents.SKIP = SKIP
	visitParents.EXIT = EXIT
	
	function visitParents(tree, test, visitor, reverse) {
	  var is
	
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  is = convert(test)
	
	  one(tree, null, [])
	
	  // Visit a single node.
	  function one(node, index, parents) {
	    var result = []
	    var subresult
	
	    if (!test || is(node, index, parents[parents.length - 1] || null)) {
	      result = toResult(visitor(node, parents))
	
	      if (result[0] === EXIT) {
	        return result
	      }
	    }
	
	    if (node.children && result[0] !== SKIP) {
	      subresult = toResult(all(node.children, parents.concat(node)))
	      return subresult[0] === EXIT ? subresult : result
	    }
	
	    return result
	  }
	
	  // Visit children in `parent`.
	  function all(children, parents) {
	    var min = -1
	    var step = reverse ? -1 : 1
	    var index = (reverse ? children.length : min) + step
	    var result
	
	    while (index > min && index < children.length) {
	      result = one(children[index], index, parents)
	
	      if (result[0] === EXIT) {
	        return result
	      }
	
	      index = typeof result[1] === 'number' ? result[1] : index + step
	    }
	  }
	}
	
	function toResult(value) {
	  if (value !== null && typeof value === 'object' && 'length' in value) {
	    return value
	  }
	
	  if (typeof value === 'number') {
	    return [CONTINUE, value]
	  }
	
	  return [value]
	}


/***/ }),

/***/ 321:
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = convert
	
	function convert(test) {
	  if (typeof test === 'string') {
	    return typeFactory(test)
	  }
	
	  if (test === null || test === undefined) {
	    return ok
	  }
	
	  if (typeof test === 'object') {
	    return ('length' in test ? anyFactory : matchesFactory)(test)
	  }
	
	  if (typeof test === 'function') {
	    return test
	  }
	
	  throw new Error('Expected function, string, or object as test')
	}
	
	function convertAll(tests) {
	  var results = []
	  var length = tests.length
	  var index = -1
	
	  while (++index < length) {
	    results[index] = convert(tests[index])
	  }
	
	  return results
	}
	
	// Utility assert each property in `test` is represented in `node`, and each
	// values are strictly equal.
	function matchesFactory(test) {
	  return matches
	
	  function matches(node) {
	    var key
	
	    for (key in test) {
	      if (node[key] !== test[key]) {
	        return false
	      }
	    }
	
	    return true
	  }
	}
	
	function anyFactory(tests) {
	  var checks = convertAll(tests)
	  var length = checks.length
	
	  return matches
	
	  function matches() {
	    var index = -1
	
	    while (++index < length) {
	      if (checks[index].apply(this, arguments)) {
	        return true
	      }
	    }
	
	    return false
	  }
	}
	
	// Utility to convert a string into a function which checks a given node’s type
	// for said string.
	function typeFactory(test) {
	  return type
	
	  function type(node) {
	    return Boolean(node && node.type === test)
	  }
	}
	
	// Utility to return true.
	function ok() {
	  return true
	}


/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	module.exports = visit
	
	var visitParents = __webpack_require__(320)
	
	var CONTINUE = visitParents.CONTINUE
	var SKIP = visitParents.SKIP
	var EXIT = visitParents.EXIT
	
	visit.CONTINUE = CONTINUE
	visit.SKIP = SKIP
	visit.EXIT = EXIT
	
	function visit(tree, test, visitor, reverse) {
	  if (typeof test === 'function' && typeof visitor !== 'function') {
	    reverse = visitor
	    visitor = test
	    test = null
	  }
	
	  visitParents(tree, test, overload, reverse)
	
	  function overload(node, parents) {
	    var parent = parents[parents.length - 1]
	    var index = parent ? parent.children.indexOf(node) : null
	    return visitor(node, index, parent)
	  }
	}


/***/ }),

/***/ 269:
/***/ (function(module, exports) {

	module.exports = {"html":"http://www.w3.org/1999/xhtml","mathml":"http://www.w3.org/1998/Math/MathML","svg":"http://www.w3.org/2000/svg","xlink":"http://www.w3.org/1999/xlink","xml":"http://www.w3.org/XML/1998/namespace","xmlns":"http://www.w3.org/2000/xmlns/"}

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),

/***/ 1163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = CopyBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CopyBlock(_ref) {
	  var title = _ref.title,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'm', position: 'topBottom', type: 'margin' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'xs', position: 'topBottom', type: 'padding' },
	      _react2.default.createElement(
	        _pageWrap2.default,
	        { size: 's' },
	        title && _react2.default.createElement(
	          _spacing2.default,
	          { size: 'l', position: 'topBottom', type: 'margin' },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h2', weight: 'semibold', size: 'xxl' },
	            title
	          )
	        ),
	        _react2.default.createElement(
	          _paragraph2.default,
	          { tag: 'p', size: 'xl' },
	          children
	        )
	      )
	    )
	  );
	}
	
	CopyBlock.propTypes = {
	  title: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = DoubleImageBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(17);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _caseStudies = __webpack_require__(78);
	
	var _caseStudies2 = _interopRequireDefault(_caseStudies);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _generalModule = __webpack_require__(1440);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_extends({}, _generalModule2.default));
	
	function DoubleImageBlock(_ref) {
	  var name = _ref.name,
	      align = _ref.align,
	      keyName = _ref.keyName;
	
	  var assets = _caseStudies2.default[name];
	  var images = assets.doubleImages[keyName];
	
	  var headingProps = {
	    tag: 'h3',
	    weight: 'semibold',
	    size: 'xxxl',
	    color: 'black'
	  };
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'm', sizeM: 'xl', position: 'topBottom', type: 'padding' },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      null,
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'xl' },
	        images.slice(0, 2).map(function (item, index) {
	          return _react2.default.createElement(
	            _grid.GridItem,
	            { key: index, columnSpan: 2, columnSpanM: 1 },
	            _react2.default.createElement(
	              'div',
	              {
	                className: cx('imageContainer', align, {
	                  last: index === 1,
	                  first: index === 0
	                })
	              },
	              item.src && _react2.default.createElement(_Image2.default, _extends({
	                hasShadow: false,
	                color: 'snow--d'
	              }, item, {
	                useImageTag: true
	              })),
	              item.copy && _react2.default.createElement(
	                _maxWidth2.default,
	                { value: item.maxWidth },
	                _react2.default.createElement(
	                  _heading2.default,
	                  headingProps,
	                  item.copy
	                )
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	}
	
	DoubleImageBlock.propTypes = {
	  name: _customPropTypesCheck2.default,
	  align: _propTypes2.default.oneOf(['center', 'offset']),
	  keyName: _propTypes2.default.string
	};
	
	DoubleImageBlock.defaultProps = {
	  align: 'center'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1440:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"imageContainer":"src-components-modules-ContentBlocks-DoubleImage-style----general-module---imageContainer---2BPT5 breakPointM-display-flex breakPointM-height-100","center":"src-components-modules-ContentBlocks-DoubleImage-style----general-module---center---1oF4- alignItems-center","first":"src-components-modules-ContentBlocks-DoubleImage-style----general-module---first---1qeqi","offset":"src-components-modules-ContentBlocks-DoubleImage-style----general-module---offset---AfeHv","last":"src-components-modules-ContentBlocks-DoubleImage-style----general-module---last---QBV5Z"};

/***/ }),

/***/ 1165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = HeroBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _caseStudies = __webpack_require__(78);
	
	var _caseStudies2 = _interopRequireDefault(_caseStudies);
	
	var _Quote = __webpack_require__(119);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	var _generalModule = __webpack_require__(1441);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HeroBlock(_ref) {
	  var boldTitle = _ref.boldTitle,
	      name = _ref.name,
	      title = _ref.title;
	
	  var assets = _caseStudies2.default[name];
	  var Logo = assets.heroLogo;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: _generalModule2.default.hero },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { size: 'm' },
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { size: 'l', sizeM: '0', type: 'margin', position: 'bottom' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'm', sizeS: 'l', sizeM: 'xl', type: 'padding' },
	            _react2.default.createElement(
	              _maxWidth2.default,
	              { value: 960 },
	              _react2.default.createElement(
	                _align2.default,
	                { type: 'center', typeM: 'left' },
	                _react2.default.createElement(
	                  _spacing2.default,
	                  { size: 'm', position: 'topBottom', type: 'margin' },
	                  _react2.default.createElement(Logo, null)
	                ),
	                _react2.default.createElement(_Quote2.default, {
	                  boldContent: boldTitle,
	                  content: title,
	                  headingSize: 'xxxxl',
	                  tag: 'h1'
	                })
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	HeroBlock.propTypes = {
	  boldTitle: _propTypes2.default.string,
	  name: _customPropTypesCheck2.default,
	  title: _customPropTypesCheck2.default
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1441:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hero":"src-components-modules-ContentBlocks-Hero-style----general-module---hero---3F1U9"};

/***/ }),

/***/ 1166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = DoubleImageBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _caseStudies = __webpack_require__(78);
	
	var _caseStudies2 = _interopRequireDefault(_caseStudies);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DoubleImageBlock(_ref) {
	  var name = _ref.name,
	      keyName = _ref.keyName;
	
	  var assets = _caseStudies2.default[name];
	  var image = assets.singleImages[keyName];
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'm', sizeS: 'l', sizeM: 'xl', position: 'topBottom', type: 'padding' },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      null,
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center' },
	        image.src && _react2.default.createElement(_Image2.default, _extends({
	          color: 'snow--d',
	          hasShadow: false
	        }, image, {
	          useImageTag: true
	        }))
	      )
	    )
	  );
	}
	
	DoubleImageBlock.propTypes = {
	  name: _customPropTypesCheck2.default,
	  keyName: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ImageQuoteBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _caseStudies = __webpack_require__(78);
	
	var _caseStudies2 = _interopRequireDefault(_caseStudies);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Quote = __webpack_require__(119);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ImageQuoteBlock(_ref) {
	  var name = _ref.name,
	      caption = _ref.caption;
	
	  var assets = _caseStudies2.default[name];
	  var image = assets.quoteImage;
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xl', position: 'topBottom', type: 'padding' },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      null,
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 2, size: 'l' },
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1, alignContent: 'center' },
	          _react2.default.createElement(_Image2.default, _extends({
	            hasShadow: false,
	            color: 'snow--d'
	          }, image, {
	            useImageTag: true
	          }))
	        ),
	        _react2.default.createElement(
	          _grid.GridItem,
	          { columnSpan: 2, columnSpanM: 1, alignContent: 'center' },
	          _react2.default.createElement(_Quote2.default, { content: caption })
	        )
	      )
	    )
	  );
	}
	
	ImageQuoteBlock.propTypes = {
	  name: _customPropTypesCheck2.default,
	  caption: _customPropTypesCheck2.default
	};
	module.exports = exports['default'];

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ImageStatsBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _caseStudies = __webpack_require__(78);
	
	var _caseStudies2 = _interopRequireDefault(_caseStudies);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _OffsetBackground = __webpack_require__(77);
	
	var _OffsetBackground2 = _interopRequireDefault(_OffsetBackground);
	
	var _generalModule = __webpack_require__(249);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ImageStatsBlock(_ref) {
	  var align = _ref.align,
	      name = _ref.name;
	
	  var assets = _caseStudies2.default[name];
	  var image = assets.statsImage,
	      features = assets.stats;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: _generalModule2.default.overflow },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'l', sizeS: 'xl', position: 'topBottom', type: 'padding' },
	      _react2.default.createElement(
	        _OffsetBackground2.default,
	        { height: 60, backgroundColor: 'licorice' },
	        image && _react2.default.createElement(
	          _pageWrap2.default,
	          null,
	          _react2.default.createElement(_Image2.default, _extends({}, image, {
	            color: 'snow--d',
	            hasShadow: false,
	            useImageTag: true
	          }))
	        ),
	        _react2.default.createElement(
	          _pageWrap2.default,
	          { size: 'l' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', sizeS: 'xl', position: 'topBottom', type: 'padding' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { position: 'topBottom', size: '0', sizeM: 'xl', type: 'padding' },
	              _react2.default.createElement(
	                _align2.default,
	                { type: align },
	                _react2.default.createElement(
	                  _maxWidth2.default,
	                  { value: 1000 },
	                  _react2.default.createElement(
	                    _grid2.default,
	                    { columns: 3, size: 'l' },
	                    features.slice(0, 3).map(function (item) {
	                      return _react2.default.createElement(
	                        _grid.GridItem,
	                        { key: item.id, columnSpan: 3, columnSpanS: 1 },
	                        _react2.default.createElement(
	                          'span',
	                          { className: _generalModule2.default.item },
	                          _react2.default.createElement(
	                            _heading2.default,
	                            {
	                              color: 'white',
	                              tag: 'div',
	                              size: 'xxxl',
	                              weight: 'semibold'
	                            },
	                            item.stat
	                          ),
	                          _react2.default.createElement(
	                            _spacing2.default,
	                            {
	                              size: 'm',
	                              position: 'topBottom',
	                              type: 'margin'
	                            },
	                            _react2.default.createElement(
	                              _heading2.default,
	                              {
	                                color: 'silver',
	                                size: 'xl',
	                                tag: 'h3',
	                                weight: 'semibold'
	                              },
	                              item.title
	                            )
	                          ),
	                          item.copy && _react2.default.createElement(
	                            _paragraph2.default,
	                            { tag: 'p', color: 'silver', size: 'l' },
	                            item.copy
	                          )
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	ImageStatsBlock.propTypes = {
	  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
	  name: _customPropTypesCheck2.default
	};
	
	ImageStatsBlock.defaultProps = {
	  align: 'center'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"overflow":"src-components-modules-ContentBlocks-ImageStats-style----general-module---overflow---UHEC9 bg-licorice breakPointM-bg-none overflow-hidden","container":"src-components-modules-ContentBlocks-ImageStats-style----general-module---container---1pc9V bg-licorice","item":"src-components-modules-ContentBlocks-ImageStats-style----general-module---item---C-m59 textAlign-left"};

/***/ }),

/***/ 1168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = QuoteBlock;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _Quote = __webpack_require__(119);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function QuoteBlock(_ref) {
	  var align = _ref.align,
	      children = _ref.children,
	      caption = _ref.caption;
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'm', sizeS: 'l', sizeM: 'xl', position: 'topBottom', type: 'margin' },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      { size: 'm' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { sizeM: 'xl', position: 'leftRight', type: 'padding' },
	        _react2.default.createElement(
	          _spacing2.default,
	          { sizeM: 'xl', position: 'leftRight', type: 'padding' },
	          _react2.default.createElement(
	            _align2.default,
	            { type: align },
	            _react2.default.createElement(_Quote2.default, {
	              boldContent: children,
	              caption: caption,
	              headingSize: 'xxxl'
	            })
	          )
	        )
	      )
	    )
	  );
	}
	
	QuoteBlock.propTypes = {
	  align: _propTypes2.default.oneOf(['left', 'right', 'center']),
	  caption: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	QuoteBlock.defaultProps = {
	  align: 'center'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1169:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouterDom = __webpack_require__(51);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _CustomerStory = __webpack_require__(566);
	
	var _CustomerStory2 = _interopRequireDefault(_CustomerStory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ReadMoreBlock(_ref) {
	  var articles = _ref.articles,
	      location = _ref.location;
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xl', position: 'topBottom', type: 'margin' },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      null,
	      _react2.default.createElement(
	        _grid2.default,
	        { columns: 3, size: 'l', alignItems: 'center' },
	        articles.filter(function (_ref2) {
	          var url = _ref2.url;
	          return location.pathname !== url;
	        }).slice(0, 3).map(function (item) {
	          return _react2.default.createElement(
	            _grid.GridItem,
	            {
	              key: item.id,
	              columnSpan: 3,
	              columnSpanM: 1,
	              alignContent: 'center'
	            },
	            _react2.default.createElement(_CustomerStory2.default, item)
	          );
	        })
	      )
	    )
	  );
	}
	
	exports.default = (0, _reactRouterDom.withRouter)(ReadMoreBlock);
	
	
	ReadMoreBlock.propTypes = {
	  articles: _propTypes2.default.array.isRequired,
	  location: _propTypes2.default.object.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouterDom = __webpack_require__(51);
	
	var _reactShare = __webpack_require__(2393);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _grid = __webpack_require__(5);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _urls = __webpack_require__(229);
	
	var _generalModule = __webpack_require__(1442);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SocialBlock(_ref) {
	  var description = _ref.description,
	      location = _ref.location,
	      title = _ref.title;
	
	  var url = '' + _urls.HOST + location.pathname;
	  return _react2.default.createElement(
	    _spacing2.default,
	    { size: 'xl', position: 'topBottom', type: 'margin' },
	    _react2.default.createElement(
	      _pageWrap2.default,
	      null,
	      _react2.default.createElement(
	        _align2.default,
	        { type: 'center' },
	        _react2.default.createElement(
	          _grid.InlineGrid,
	          { alignContent: 'middle' },
	          _react2.default.createElement('div', { className: _generalModule2.default.border }),
	          _react2.default.createElement(
	            'div',
	            { className: _generalModule2.default.hover },
	            _react2.default.createElement(
	              _reactShare.FacebookShareButton,
	              { quote: title, url: url },
	              _react2.default.createElement(_reactShare.FacebookIcon, { round: true, size: 40 })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _generalModule2.default.hover },
	            _react2.default.createElement(
	              _reactShare.LinkedinShareButton,
	              {
	                title: title,
	                description: description,
	                url: url
	              },
	              _react2.default.createElement(_reactShare.LinkedinIcon, { round: true, size: 40 })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _generalModule2.default.hover },
	            _react2.default.createElement(
	              _reactShare.TwitterShareButton,
	              { title: title, url: url },
	              _react2.default.createElement(_reactShare.TwitterIcon, { round: true, size: 40 })
	            )
	          ),
	          _react2.default.createElement('div', { className: _generalModule2.default.border })
	        )
	      )
	    )
	  );
	}
	
	exports.default = (0, _reactRouterDom.withRouter)(SocialBlock);
	
	
	SocialBlock.propTypes = {
	  location: _propTypes2.default.object.isRequired,
	  description: _propTypes2.default.string,
	  title: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 1442:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"border":"src-components-modules-ContentBlocks-Social-style----general-module---border---31tW9 bg-smoke","hover":"src-components-modules-ContentBlocks-Social-style----general-module---hover---3m_yO cursor-pointer outline-none scaleUp--hover transitionDuration-m transitionProperty-all transitionTimingFunction-cb--scaleUp"};

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Cta;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _align = __webpack_require__(11);
	
	var _align2 = _interopRequireDefault(_align);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Cta() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'bg-licorice' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { size: 'l', sizeM: 'xl', position: 'topBottom', type: 'padding' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'l', sizeM: 'xl', position: 'top', type: 'padding' },
	        _react2.default.createElement(
	          _align2.default,
	          { type: 'center' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'l', position: 'bottom', type: 'margin' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 'm', sizeM: '0', position: 'leftRight', type: 'padding' },
	              _react2.default.createElement(
	                _maxWidth2.default,
	                { value: 760 },
	                _react2.default.createElement(
	                  _heading2.default,
	                  { size: 'xxxl', weight: 'semibold', color: 'white' },
	                  'Make design your company\'s competitive edge.'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/enterprise' },
	            _react2.default.createElement(
	              _button2.default,
	              { shape: 'rounded', size: 'large' },
	              'Discover Marvel Enterprise'
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = CustomerStory;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _generalModule = __webpack_require__(733);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CustomerStory(_ref) {
	  var url = _ref.url,
	      image = _ref.image,
	      title = _ref.title,
	      logo = _ref.logo;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    url ? _react2.default.createElement(
	      'div',
	      { className: _generalModule2.default.hover },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: url },
	        _react2.default.createElement(
	          _link2.default,
	          { type: 'light' },
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'm', position: 'bottom', type: 'margin' },
	            _react2.default.createElement(
	              'div',
	              { className: _generalModule2.default.imageHover },
	              _react2.default.createElement(_Image2.default, _extends({}, image, { maxWidth: '100%', hasShadow: false }))
	            )
	          ),
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'm', position: 'bottom', type: 'margin' },
	            _react2.default.createElement(
	              _paragraph2.default,
	              { tag: 'div', size: 'l' },
	              title
	            )
	          ),
	          logo
	        )
	      )
	    ) : _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'm', position: 'bottom', type: 'margin' },
	        _react2.default.createElement(_Image2.default, _extends({}, image, { maxWidth: '100%', hasShadow: false }))
	      ),
	      _react2.default.createElement(
	        _spacing2.default,
	        { size: 'm', position: 'bottom', type: 'margin' },
	        _react2.default.createElement(
	          _paragraph2.default,
	          { tag: 'div', size: 'l' },
	          title
	        )
	      ),
	      logo
	    )
	  );
	}
	
	CustomerStory.propTypes = {
	  url: _propTypes2.default.string,
	  image: _propTypes2.default.object,
	  title: _propTypes2.default.string,
	  logo: _propTypes2.default.node
	};
	module.exports = exports['default'];

/***/ }),

/***/ 733:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"hover":"src-components-modules-CustomerStory-style----general-module---hover---213Cb transitionTimingFunction-cv-easeOutCircular transitionDuration-xl","imageHover":"src-components-modules-CustomerStory-style----general-module---imageHover---3fj83 overflow-hidden textAlign-center breakPointM-textAlign-left"};

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Quote;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bind = __webpack_require__(17);
	
	var _bind2 = _interopRequireDefault(_bind);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	var _iconModule = __webpack_require__(260);
	
	var _iconModule2 = _interopRequireDefault(_iconModule);
	
	var _backgroundModule = __webpack_require__(258);
	
	var _backgroundModule2 = _interopRequireDefault(_backgroundModule);
	
	var _generalModule = __webpack_require__(259);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _bind2.default.bind(_extends({}, _backgroundModule2.default, _iconModule2.default));
	
	var bgValues = ['marvel', 'green', 'teal', 'yellow', 'orange', 'pink', 'purple', 'red'];
	
	function Quote(_ref) {
	  var boldContent = _ref.boldContent,
	      caption = _ref.caption,
	      content = _ref.content,
	      headingSize = _ref.headingSize,
	      icon = _ref.icon,
	      iconColor = _ref.iconColor,
	      isLight = _ref.isLight,
	      linkText = _ref.linkText,
	      linkUrl = _ref.linkUrl,
	      tag = _ref.tag;
	
	  var headingProps = {
	    tag: tag,
	    weight: 'regular',
	    size: headingSize,
	    color: isLight ? 'white' : 'black'
	  };
	  var iconClassName = cx('icon', iconColor);
	  var Icon = icon;
	  var iconProps = {
	    className: iconClassName,
	    style: {
	      width: '40px',
	      height: '40px'
	    }
	  };
	
	  return _react2.default.createElement(
	    'figure',
	    null,
	    icon && (iconColor ? _react2.default.createElement(
	      'div',
	      iconProps,
	      _react2.default.createElement(Icon, null)
	    ) : _react2.default.createElement(Icon, null)),
	    _react2.default.createElement(
	      'blockquote',
	      { className: _generalModule2.default.heading },
	      _react2.default.createElement(
	        _heading2.default,
	        headingProps,
	        boldContent && _react2.default.createElement(
	          'span',
	          { className: 'fontWeight-6' },
	          boldContent
	        ),
	        ' ',
	        content
	      )
	    ),
	    caption && _react2.default.createElement(
	      'figcaption',
	      { className: _generalModule2.default.caption },
	      _react2.default.createElement(
	        _paragraph2.default,
	        { color: isLight ? 'smoke' : 'slate', size: 'm' },
	        caption,
	        ' ',
	        linkText && _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: linkUrl },
	          _react2.default.createElement(
	            _link2.default,
	            { type: isLight ? 'blue' : 'blue' },
	            _react2.default.createElement(
	              'span',
	              { className: 'fontWeight-5' },
	              linkText
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	Quote.propTypes = {
	  boldContent: _propTypes2.default.string,
	  caption: _propTypes2.default.string,
	  content: _customPropTypesCheck2.default,
	  headingSize: _propTypes2.default.oneOf(['xxl', 'xxxl', 'xxxxl']),
	  icon: _propTypes2.default.func,
	  iconColor: _propTypes2.default.oneOf(bgValues),
	  isLight: _propTypes2.default.bool,
	  linkText: _propTypes2.default.string,
	  linkUrl: _propTypes2.default.string,
	  tag: _propTypes2.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5'])
	};
	
	Quote.defaultProps = {
	  isLight: false,
	  headingSize: 'xxl',
	  tag: 'h3'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"marvel":"src-components-modules-Quote-style----background-module---marvel---1ju4u bg-marvel","green":"src-components-modules-Quote-style----background-module---green---1XAIQ bg-green","teal":"src-components-modules-Quote-style----background-module---teal---2emPp bg-teal","yellow":"src-components-modules-Quote-style----background-module---yellow---2POad bg-yellow","orange":"src-components-modules-Quote-style----background-module---orange---2eGLm bg-orange","pink":"src-components-modules-Quote-style----background-module---pink---gSBHq bg-pink","purple":"src-components-modules-Quote-style----background-module---purple---3Tth- bg-purple","red":"src-components-modules-Quote-style----background-module---red---2e257 bg-red"};

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"heading":"src-components-modules-Quote-style----general-module---heading---243Zz","caption":"src-components-modules-Quote-style----general-module---caption---3iape marginTop-s"};

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"icon":"src-components-modules-Quote-style----icon-module---icon---1rokL alignItems-center borderRadius-circle display-flex fill-white justifyContent-center marginBottom-m"};

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BuzzfeedFull = __webpack_require__(183);
	
	var _BuzzfeedFull2 = _interopRequireDefault(_BuzzfeedFull);
	
	var _cover2x = __webpack_require__(113);
	
	var _cover2x2 = _interopRequireDefault(_cover2x);
	
	var _stats2x = __webpack_require__(333);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(327);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(328);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(329);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(330);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image032x = __webpack_require__(331);
	
	var _image032x2 = _interopRequireDefault(_image032x);
	
	var _quote2x = __webpack_require__(332);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buzzfeedAssets = {
	  heroImage: {
	    src: _cover2x2.default,
	    srcSet: _cover2x2.default,
	    maxWidth: 504,
	    alt: ''
	  },
	  heroLogo: _BuzzfeedFull2.default,
	  statsImage: {
	    src: _stats2x2.default,
	    srcSet: _stats2x2.default,
	    maxWidth: 1290,
	    alt: ''
	  },
	  stats: [{
	    id: 0,
	    stat: '700',
	    title: 'Projects',
	    copy: 'Marvel supports their global business scale of work and high project activity'
	  }, {
	    id: 1,
	    stat: '6000',
	    title: 'Designs',
	    copy: 'Marvel high number of designs uploaded by their 20 strong design team '
	  }, {
	    id: 2,
	    stat: '55',
	    title: 'Users',
	    copy: 'Designers use Marvel to share work with content and other teams across the company '
	  }],
	  singleImages: {
	    first: {
	      src: _image032x2.default,
	      maxWidth: 1141,
	      alt: ''
	    }
	  },
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 494,
	      alt: ''
	    }],
	    second: [{
	      src: _quote2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      maxWidth: 490,
	      copy: '"Marvel is a tool in our designers’ toolkit for them to share their work and what stage it’s in with the rest of the team"'
	    }],
	    third: [{
	      src: _image02A2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }]
	  }
	};
	
	exports.default = buzzfeedAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _CabifyFull = __webpack_require__(185);
	
	var _CabifyFull2 = _interopRequireDefault(_CabifyFull);
	
	var _stats22x = __webpack_require__(342);
	
	var _stats22x2 = _interopRequireDefault(_stats22x);
	
	var _image00A2x = __webpack_require__(334);
	
	var _image00A2x2 = _interopRequireDefault(_image00A2x);
	
	var _image00B2x = __webpack_require__(335);
	
	var _image00B2x2 = _interopRequireDefault(_image00B2x);
	
	var _image01A2x = __webpack_require__(336);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(337);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(338);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02C2x = __webpack_require__(339);
	
	var _image02C2x2 = _interopRequireDefault(_image02C2x);
	
	var _quote2x = __webpack_require__(341);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	var _image032x = __webpack_require__(340);
	
	var _image032x2 = _interopRequireDefault(_image032x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cabifyAssets = {
	  heroLogo: _CabifyFull2.default,
	  statsImage: {
	    src: _stats22x2.default,
	    srcSet: _stats22x2.default,
	    alt: ''
	  },
	  stats: [{
	    id: 0,
	    stat: '15 mins',
	    title: 'Feedback time',
	    copy: 'Marvel’s commenting and collaboration features closed feedback loops for Cabify.'
	  }, {
	    id: 1,
	    stat: '1 week',
	    title: 'Shipping time',
	    copy: 'Cabify accelerate their design process through prototyping and testing with Marvel'
	  }, {
	    id: 2,
	    stat: '400%',
	    title: 'Time reduction',
	    copy: 'The team have seen a 400% reduction in time it takes to design and prototype new features'
	  }],
	  doubleImages: {
	    zero: [{
	      src: _image00A2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      src: _image00B2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }],
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 494,
	      alt: ''
	    }],
	    second: [{
	      src: _quote2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      maxWidth: 490,
	      copy: '"Marvel has become the first touch point between designers and the rest of the team."'
	    }],
	    third: [{
	      src: _image02A2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      src: _image02C2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }]
	  },
	  singleImages: {
	    first: {
	      src: _image032x2.default,
	      maxWidth: 1141,
	      alt: ''
	    }
	  }
	};
	
	exports.default = cabifyAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _cookpadFull = __webpack_require__(197);
	
	var _cookpadFull2 = _interopRequireDefault(_cookpadFull);
	
	var _stats2x = __webpack_require__(352);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(343);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(344);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(345);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(346);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image03A2x = __webpack_require__(347);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(348);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _image04A2x = __webpack_require__(349);
	
	var _image04A2x2 = _interopRequireDefault(_image04A2x);
	
	var _image04BAlternative2x = __webpack_require__(350);
	
	var _image04BAlternative2x2 = _interopRequireDefault(_image04BAlternative2x);
	
	var _quote2x = __webpack_require__(351);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cookPadAssets = {
	  heroLogo: _cookpadFull2.default,
	  statsImage: {
	    alt: 'Marvel Prototyping used by CookPad',
	    maxWidth: 1290,
	    src: _stats2x2.default
	  },
	  stats: [{
	    id: 0,
	    stat: '100',
	    title: 'validation tests',
	    copy: 'Cookpad run tests with Marvel for Product Discovery across 5 squads each week'
	  }, {
	    id: 1,
	    stat: '35',
	    title: 'countries globally',
	    copy: 'Their design teams test with their international audiences around the world using Marvel prototypes'
	  }, {
	    id: 2,
	    stat: '100',
	    title: 'million users',
	    copy: 'Every month Cookpad has over 100 million users visit their platform'
	  }],
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 536,
	      alt: 'collaboration'
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 551,
	      alt: 'team meetings'
	    }],
	    second: [{
	      src: _image02A2x2.default,
	      maxWidth: 550,
	      alt: 'iOS prototyping'
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 550,
	      alt: 'cooking'
	    }],
	    third: [{
	      src: _image03A2x2.default,
	      maxWidth: 556,
	      alt: 'Cookpad and Marvel'
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 556,
	      alt: 'Marvel and Cookpad'
	    }],
	    fourth: [{
	      src: _image04A2x2.default,
	      maxWidth: 556,
	      alt: 'Cookpad and Marvel'
	    }, {
	      src: _image04BAlternative2x2.default,
	      maxWidth: 550,
	      alt: 'iOS and desktop prototyping'
	    }],
	    fifth: [{
	      src: _quote2x2.default,
	      maxWidth: 556,
	      alt: 'mobile prototyping'
	    }, {
	      maxWidth: 440,
	      copy: '“We use the Sketch integration primarily, which syncs with Marvel and instantly updates as we need to. It takes no time at all.”'
	    }]
	  }
	};
	
	exports.default = cookPadAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DeliverooFull = __webpack_require__(186);
	
	var _DeliverooFull2 = _interopRequireDefault(_DeliverooFull);
	
	var _cover2x = __webpack_require__(114);
	
	var _cover2x2 = _interopRequireDefault(_cover2x);
	
	var _stats2x = __webpack_require__(362);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(353);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(354);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(355);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(356);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image03A2x = __webpack_require__(357);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(358);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _image04A2x = __webpack_require__(359);
	
	var _image04A2x2 = _interopRequireDefault(_image04A2x);
	
	var _image04B2x = __webpack_require__(360);
	
	var _image04B2x2 = _interopRequireDefault(_image04B2x);
	
	var _imageQuote2x = __webpack_require__(361);
	
	var _imageQuote2x2 = _interopRequireDefault(_imageQuote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deliverooAssets = {
	  heroImage: {
	    src: _cover2x2.default,
	    srcSet: _cover2x2.default,
	    alt: '',
	    maxWidth: 504
	  },
	  heroLogo: _DeliverooFull2.default,
	  statsImage: {
	    alt: '',
	    maxWidth: 1290,
	    src: _stats2x2.default
	  },
	  stats: [{
	    id: 0,
	    stat: '2+',
	    title: 'Years as a Marvel customer',
	    copy: 'Deliveroo have been prototyping and scaling at pace with Marvel since November 2015'
	  }, {
	    id: 1,
	    stat: '20',
	    title: 'Designers using Marvel',
	    copy: 'Their team of 20 designers use Marvel to share designs, prototypes and iterate fast.'
	  }, {
	    id: 2,
	    stat: '15',
	    title: 'Research & content users',
	    copy: 'Marvel isn\'t restricted to designers at Deliveroo, it fits with their collaborative culture'
	  }],
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 551,
	      alt: ''
	    }],
	    second: [{
	      src: _image02A2x2.default,
	      maxWidth: 460,
	      alt: ''
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 460,
	      alt: ''
	    }],
	    third: [{
	      src: _image03A2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }],
	    fourth: [{
	      src: _imageQuote2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      maxWidth: 440,
	      copy: '"We use Marvel a lot for user testing. Actually being able to create a scenario, prepare a flow for a person and have them walk through it step-by-step creates such valuable feedback."'
	    }],
	    fifth: [{
	      src: _image04A2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      src: _image04B2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }]
	  }
	};
	
	exports.default = deliverooAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DesignMuseumFull = __webpack_require__(187);
	
	var _DesignMuseumFull2 = _interopRequireDefault(_DesignMuseumFull);
	
	var _stats2x = __webpack_require__(374);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(363);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(364);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(365);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(366);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image03A2x = __webpack_require__(367);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(368);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _image042x = __webpack_require__(371);
	
	var _image042x2 = _interopRequireDefault(_image042x);
	
	var _image04A2x = __webpack_require__(369);
	
	var _image04A2x2 = _interopRequireDefault(_image04A2x);
	
	var _image04B2x = __webpack_require__(370);
	
	var _image04B2x2 = _interopRequireDefault(_image04B2x);
	
	var _image05A2x = __webpack_require__(372);
	
	var _image05A2x2 = _interopRequireDefault(_image05A2x);
	
	var _image05B2x = __webpack_require__(373);
	
	var _image05B2x2 = _interopRequireDefault(_image05B2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var designMuseumAssets = {
	  heroLogo: _DesignMuseumFull2.default,
	  statsImage: {
	    alt: 'students using Marvel Prototyping',
	    maxWidth: 1290,
	    src: _stats2x2.default
	  },
	  stats: [{
	    id: 0,
	    stat: '216+',
	    title: 'design students',
	    copy: 'joined their app design workshop since the beginning of 2017/2018'
	  }, {
	    id: 1,
	    stat: '20',
	    title: 'students per session',
	    copy: 'The Design Museum has small sized classes to provide students with a tailored experience '
	  }, {
	    id: 2,
	    stat: '5',
	    title: 'minutes or less',
	    copy: 'is the time it takes to introduce Marvel to the kids and get them started with their project'
	  }],
	  singleImages: {
	    first: {
	      src: _image042x2.default,
	      maxWidth: 1141,
	      alt: 'Students use Marvel’s Design Tool'
	    }
	  },
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 536,
	      alt: 'Design Museum Interior'
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 551,
	      alt: 'Teacher teaching students how to use Marvel Prototyping'
	    }],
	    second: [{
	      src: _image02A2x2.default,
	      maxWidth: 580,
	      alt: 'Paper sketching of prototypes'
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 558,
	      alt: 'Students start their first project using Marvel'
	    }],
	    third: [{
	      src: _image03A2x2.default,
	      maxWidth: 536,
	      alt: 'paper prototyping'
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 550,
	      alt: 'Students using Marvel on desktop'
	    }],
	    fourth: [{
	      src: _image04A2x2.default,
	      maxWidth: 460,
	      alt: 'Students using Marvel on desktop'
	    }, {
	      src: _image04B2x2.default,
	      maxWidth: 460,
	      alt: 'Marvel Prototyping and Design Museum'
	    }],
	    fifth: [{
	      src: _image05A2x2.default,
	      maxWidth: 556,
	      alt: 'Students using Marvel on desktop'
	    }, {
	      src: _image05B2x2.default,
	      maxWidth: 556,
	      alt: 'Students using Marvel on desktop'
	    }]
	  }
	};
	
	exports.default = designMuseumAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var enterpriseAssets = {
	  stats: [{
	    id: 0,
	    stat: '30%',
	    title: 'Faster',
	    copy: 'Experience seamless collaboration across teams and accelerated creative workflows.'
	  }, {
	    id: 1,
	    stat: '75%',
	    title: 'Of the Fortune 100',
	    copy: "Trusted partner of over 100,000 organisations, including the world's largest."
	  }, {
	    id: 2,
	    stat: '99.9%',
	    title: 'Uptime SLA',
	    copy: 'Reliability is critical to any products success, we pride ourselves on always being there.'
	  }]
	};
	
	exports.default = enterpriseAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _HudlFull = __webpack_require__(188);
	
	var _HudlFull2 = _interopRequireDefault(_HudlFull);
	
	var _cover2x = __webpack_require__(113);
	
	var _cover2x2 = _interopRequireDefault(_cover2x);
	
	var _stats2x = __webpack_require__(383);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image00A2x = __webpack_require__(375);
	
	var _image00A2x2 = _interopRequireDefault(_image00A2x);
	
	var _image00B2x = __webpack_require__(376);
	
	var _image00B2x2 = _interopRequireDefault(_image00B2x);
	
	var _image01A2x = __webpack_require__(377);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(378);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image022x = __webpack_require__(379);
	
	var _image022x2 = _interopRequireDefault(_image022x);
	
	var _image03A2x = __webpack_require__(380);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(381);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _quote2x = __webpack_require__(382);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hudlAssets = {
	  heroImage: {
	    src: _cover2x2.default,
	    srcSet: _cover2x2.default,
	    alt: ''
	  },
	  heroLogo: _HudlFull2.default,
	  statsImage: {
	    src: _stats2x2.default,
	    srcSet: _stats2x2.default,
	    maxWidth: 1290,
	    alt: ''
	  },
	  stats: [{
	    id: 0,
	    stat: '2x',
	    title: 'Prototyping speed',
	    copy: 'Hudl found that their designers created prototypes twice as fast with Marvel'
	  }, {
	    id: 1,
	    stat: '160+',
	    title: 'Screens in a project',
	    copy: 'Marvel enables Hudl’s high fidelity, large scale prototypes which reach 160 screens'
	  }, {
	    id: 2,
	    stat: '16',
	    title: 'Concurrent projects',
	    copy: 'Hudl work on 16+ projects at a time and Marvel gives them a stable, solid platform to do so '
	  }],
	  doubleImages: {
	    zero: [{
	      src: _image00A2x2.default,
	      maxWidth: 460,
	      alt: ''
	    }, {
	      src: _image00B2x2.default,
	      maxWidth: 460,
	      alt: ''
	    }],
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }],
	    second: [{
	      src: _image03A2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }],
	    third: [{
	      src: _quote2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      maxWidth: 520,
	      copy: '"We don’t release anything without some kind of testing. Every morning in our Slack channel we get an automatic update for our research department with scheduled research events. We test daily."'
	    }]
	  },
	  singleImages: {
	    first: {
	      src: _image022x2.default,
	      maxWidth: 1141,
	      alt: ''
	    }
	  }
	};
	
	exports.default = hudlAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _buzzfeed = __webpack_require__(212);
	
	var _buzzfeed2 = _interopRequireDefault(_buzzfeed);
	
	var _cabify = __webpack_require__(213);
	
	var _cabify2 = _interopRequireDefault(_cabify);
	
	var _cookpad = __webpack_require__(214);
	
	var _cookpad2 = _interopRequireDefault(_cookpad);
	
	var _deliveroo = __webpack_require__(215);
	
	var _deliveroo2 = _interopRequireDefault(_deliveroo);
	
	var _designmuseum = __webpack_require__(216);
	
	var _designmuseum2 = _interopRequireDefault(_designmuseum);
	
	var _enterprise = __webpack_require__(217);
	
	var _enterprise2 = _interopRequireDefault(_enterprise);
	
	var _hudl = __webpack_require__(218);
	
	var _hudl2 = _interopRequireDefault(_hudl);
	
	var _laboratoria = __webpack_require__(219);
	
	var _laboratoria2 = _interopRequireDefault(_laboratoria);
	
	var _mode = __webpack_require__(220);
	
	var _mode2 = _interopRequireDefault(_mode);
	
	var _monzo = __webpack_require__(221);
	
	var _monzo2 = _interopRequireDefault(_monzo);
	
	var _nokia = __webpack_require__(222);
	
	var _nokia2 = _interopRequireDefault(_nokia);
	
	var _yieldr = __webpack_require__(225);
	
	var _yieldr2 = _interopRequireDefault(_yieldr);
	
	var _security = __webpack_require__(223);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _trusona = __webpack_require__(224);
	
	var _trusona2 = _interopRequireDefault(_trusona);
	
	var _zinc = __webpack_require__(226);
	
	var _zinc2 = _interopRequireDefault(_zinc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  buzzfeed: _buzzfeed2.default,
	  cabify: _cabify2.default,
	  cookpad: _cookpad2.default,
	  deliveroo: _deliveroo2.default,
	  designMuseum: _designmuseum2.default,
	  enterprise: _enterprise2.default,
	  hudl: _hudl2.default,
	  security: _security2.default,
	  laboratoria: _laboratoria2.default,
	  mode: _mode2.default,
	  monzo: _monzo2.default,
	  nokia: _nokia2.default,
	  yieldr: _yieldr2.default,
	  trusona: _trusona2.default,
	  zinc: _zinc2.default
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LaboratoriaFull = __webpack_require__(189);
	
	var _LaboratoriaFull2 = _interopRequireDefault(_LaboratoriaFull);
	
	var _stats2x = __webpack_require__(394);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(384);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(385);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(386);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(387);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image032x = __webpack_require__(390);
	
	var _image032x2 = _interopRequireDefault(_image032x);
	
	var _image03A2x = __webpack_require__(388);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(389);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _image04A2x = __webpack_require__(391);
	
	var _image04A2x2 = _interopRequireDefault(_image04A2x);
	
	var _image04B2x = __webpack_require__(392);
	
	var _image04B2x2 = _interopRequireDefault(_image04B2x);
	
	var _image052x = __webpack_require__(393);
	
	var _image052x2 = _interopRequireDefault(_image052x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var laboratoriaAssets = {
	  heroLogo: _LaboratoriaFull2.default,
	  statsImage: {
	    src: _stats2x2.default,
	    srcSet: _stats2x2.default,
	    maxWidth: 1290,
	    alt: 'Laboratoria at ideation stage'
	  },
	  stats: [{
	    id: 0,
	    stat: '80%',
	    title: 'employment success rate',
	    copy: 'Laboratoria hopes to increase their graduate employment success rate to 85%.'
	  }, {
	    id: 1,
	    stat: '800+',
	    title: 'students',
	    copy: 'Since their launch in 2014 Laboratoria have taught more than 800 students in their program.'
	  }, {
	    id: 2,
	    stat: '200+',
	    title: 'UX design graduates',
	    copy: 'since introducing their UX Design course in 2017, which uses Marvel.'
	  }],
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 536,
	      alt: 'Laboratoria plan projects'
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 550,
	      alt: 'Laboratoria and Marvel App'
	    }],
	    second: [{
	      src: _image02A2x2.default,
	      maxWidth: 556,
	      alt: 'Laboratoria Study Sessions'
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 556,
	      alt: 'Code Editor at Laboratoria'
	    }],
	    third: [{
	      src: _image03A2x2.default,
	      maxWidth: 556,
	      alt: 'planning and strategy'
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 556,
	      alt: 'planning and strategy'
	    }],
	    fourth: [{
	      src: _image04A2x2.default,
	      maxWidth: 556,
	      alt: 'collaboration at Laboratoria with Marvel App'
	    }, {
	      src: _image04B2x2.default,
	      maxWidth: 556,
	      alt: 'collaboration at Laboratoria with Marvel App'
	    }]
	  },
	  singleImages: {
	    first: {
	      src: _image032x2.default,
	      maxWidth: 1141,
	      alt: 'team work at Laboratoria'
	    },
	    second: {
	      src: _image052x2.default,
	      maxWidth: 1141,
	      alt: 'team work at Laboratoria'
	    }
	  }
	};
	
	exports.default = laboratoriaAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ModeFull = __webpack_require__(191);
	
	var _ModeFull2 = _interopRequireDefault(_ModeFull);
	
	var _image01A2x = __webpack_require__(395);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(396);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image032x = __webpack_require__(397);
	
	var _image032x2 = _interopRequireDefault(_image032x);
	
	var _image04A2x = __webpack_require__(398);
	
	var _image04A2x2 = _interopRequireDefault(_image04A2x);
	
	var _image04B2x = __webpack_require__(399);
	
	var _image04B2x2 = _interopRequireDefault(_image04B2x);
	
	var _image05A2x = __webpack_require__(400);
	
	var _image05A2x2 = _interopRequireDefault(_image05A2x);
	
	var _image05B2x = __webpack_require__(401);
	
	var _image05B2x2 = _interopRequireDefault(_image05B2x);
	
	var _stats2x = __webpack_require__(403);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _quote2x = __webpack_require__(402);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modeAssets = {
	  heroLogo: _ModeFull2.default,
	  statsImage: {
	    alt: 'Mode employee’s working in open office space',
	    maxWidth: 1290,
	    src: _stats2x2.default
	  },
	  singleImages: {
	    first: {
	      src: _image032x2.default,
	      maxWidth: 1141,
	      alt: 'A meeting in Mode'
	    }
	  },
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 536,
	      alt: 'Person working with charts and analytic tools'
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 551,
	      alt: 'People working with charts and analytic tools'
	    }],
	    second: [{
	      src: _image04A2x2.default,
	      maxWidth: 600,
	      alt: 'Developer uses Handoff with Marvel'
	    }, {
	      src: _image04B2x2.default,
	      maxWidth: 600,
	      alt: 'Prototyping with Marvel at Mode'
	    }],
	    third: [{
	      src: _image05A2x2.default,
	      maxWidth: 600,
	      alt: 'Mode employees working with analytics'
	    }, {
	      src: _image05B2x2.default,
	      maxWidth: 600,
	      alt: 'Mode employees working with analytics'
	    }],
	    fourth: [{
	      src: _quote2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }, {
	      maxWidth: 450,
	      copy: '“Handoff is actually the biggest thing that we use on the product team. I can′t tell you how much time it saves in terms of making redlines or helping go back and forth with front-end engineering about anything from padding to colours to font weights."'
	    }]
	  },
	  stats: [{
	    id: 0,
	    stat: '1,260',
	    title: 'comments',
	    copy: 'on Marvel prototypes between design, product managers, engineers, and marketing'
	  }, {
	    id: 1,
	    stat: '140',
	    title: 'projects',
	    copy: 'spanning various product areas and marketing functions'
	  }, {
	    id: 2,
	    stat: '3',
	    title: 'hours',
	    copy: 'of time saved per project with Prototypes and Handoff'
	  }]
	};
	
	exports.default = modeAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MonzoFull = __webpack_require__(192);
	
	var _MonzoFull2 = _interopRequireDefault(_MonzoFull);
	
	var _cover2x = __webpack_require__(114);
	
	var _cover2x2 = _interopRequireDefault(_cover2x);
	
	var _image01a2x = __webpack_require__(404);
	
	var _image01a2x2 = _interopRequireDefault(_image01a2x);
	
	var _image01b2x = __webpack_require__(405);
	
	var _image01b2x2 = _interopRequireDefault(_image01b2x);
	
	var _image02a2x = __webpack_require__(406);
	
	var _image02a2x2 = _interopRequireDefault(_image02a2x);
	
	var _image02b2x = __webpack_require__(407);
	
	var _image02b2x2 = _interopRequireDefault(_image02b2x);
	
	var _image03a2x = __webpack_require__(408);
	
	var _image03a2x2 = _interopRequireDefault(_image03a2x);
	
	var _image04a2x = __webpack_require__(409);
	
	var _image04a2x2 = _interopRequireDefault(_image04a2x);
	
	var _image05a2x = __webpack_require__(410);
	
	var _image05a2x2 = _interopRequireDefault(_image05a2x);
	
	var _image05b2x = __webpack_require__(411);
	
	var _image05b2x2 = _interopRequireDefault(_image05b2x);
	
	var _monzoStats2x = __webpack_require__(412);
	
	var _monzoStats2x2 = _interopRequireDefault(_monzoStats2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var monzoAssets = {
	  heroImage: {
	    src: _cover2x2.default,
	    srcSet: _cover2x2.default,
	    alt: ''
	  },
	  heroLogo: _MonzoFull2.default,
	  statsImage: {
	    alt: '',
	    maxWidth: 1290,
	    src: _monzoStats2x2.default
	  },
	  singleImages: {
	    first: {
	      src: _image04a2x2.default,
	      maxWidth: 1141,
	      alt: ''
	    }
	  },
	  doubleImages: {
	    first: [{
	      src: _image01a2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      src: _image01b2x2.default,
	      maxWidth: 551,
	      alt: ''
	    }],
	    second: [{
	      src: _image02a2x2.default,
	      maxWidth: 460,
	      alt: ''
	    }, {
	      src: _image05b2x2.default,
	      maxWidth: 494,
	      alt: ''
	    }],
	    third: [{
	      src: _image03a2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      maxWidth: 400,
	      copy: '"The last designer to join the team, she was onboarded with Marvel in 30 minutes, which is really quick."'
	    }],
	    fourth: [{
	      src: _image05a2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }, {
	      src: _image02b2x2.default,
	      maxWidth: 460,
	      alt: ''
	    }]
	  },
	  stats: [{
	    id: 0,
	    stat: '3000',
	    title: 'Artboards',
	    copy: "Marvel is compatible with Sketch and supported the team's big projects"
	  }, {
	    id: 1,
	    stat: '100+',
	    title: 'Prototypes',
	    copy: 'Marvel enables the team to scale and supports high volumes of projects'
	  }, {
	    id: 2,
	    stat: '2',
	    title: 'Weeks to Ship',
	    copy: 'Prototyping with Marvel allows the team to accelerate their entire design process'
	  }]
	};
	
	exports.default = monzoAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NokiaFull = __webpack_require__(193);
	
	var _NokiaFull2 = _interopRequireDefault(_NokiaFull);
	
	var _nokiaHero = __webpack_require__(415);
	
	var _nokiaHero2 = _interopRequireDefault(_nokiaHero);
	
	var _nokia = __webpack_require__(413);
	
	var _nokia2 = _interopRequireDefault(_nokia);
	
	var _nokia3 = __webpack_require__(414);
	
	var _nokia4 = _interopRequireDefault(_nokia3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nokiaAssets = {
	  heroLogo: _NokiaFull2.default,
	  statsImage: {
	    src: _nokiaHero2.default,
	    srcSet: _nokiaHero2.default,
	    alt: 'A large Nokia logo on a wall'
	  },
	  stats: [{
	    id: 0,
	    stat: '90,000',
	    title: 'Employees',
	    copy: 'Located all around the world'
	  }, {
	    id: 1,
	    stat: '5',
	    title: 'UX design team locations',
	    copy: 'The UX teams are spread across India, Bulgaria, Canada, Portugal and Finland. Marvel helps them work successfully across all these different time zones.'
	  }, {
	    id: 2,
	    stat: '320',
	    title: 'People using Marvel',
	    copy: 'All happily collaborating on design ideas, across the entire company.'
	  }],
	  singleImages: {
	    first: {
	      src: _nokia2.default,
	      srcSet: _nokia2.default,
	      alt: 'Two people sit at a table with laptops having a discussion',
	      maxWidth: 1350
	    },
	    second: {
	      src: _nokia4.default,
	      srcSet: _nokia4.default,
	      alt: 'A group of people sit around a table in a meeting room',
	      maxWidth: 1350
	    }
	  }
	};
	
	exports.default = nokiaAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var securityAssets = {
	  stats: [{
	    id: 0,
	    stat: '99.98%',
	    title: 'Uptime SLA',
	    copy: 'Our distributed infrastructure means you get the best and most reliable experience possible, no matter where your business is located'
	  }, {
	    id: 1,
	    stat: '24/7',
	    title: 'Support',
	    copy: 'Our global support team covers each timezone, with escalation procedures​ to ensure that urgent issues are swiftly resolved'
	  }, {
	    id: 2,
	    stat: 'GDPR',
	    title: 'Compliant',
	    copy: 'Marvel is fully commited to meeting our legal obligation with the latest GDPR regulation and protecting the data rights of our customers'
	  }]
	};
	
	exports.default = securityAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TrusonaFull = __webpack_require__(194);
	
	var _TrusonaFull2 = _interopRequireDefault(_TrusonaFull);
	
	var _stats22x = __webpack_require__(421);
	
	var _stats22x2 = _interopRequireDefault(_stats22x);
	
	var _image_01_a2x = __webpack_require__(416);
	
	var _image_01_a2x2 = _interopRequireDefault(_image_01_a2x);
	
	var _image_01_b2x = __webpack_require__(417);
	
	var _image_01_b2x2 = _interopRequireDefault(_image_01_b2x);
	
	var _image_02_a2x = __webpack_require__(418);
	
	var _image_02_a2x2 = _interopRequireDefault(_image_02_a2x);
	
	var _image_02_b2x = __webpack_require__(419);
	
	var _image_02_b2x2 = _interopRequireDefault(_image_02_b2x);
	
	var _image_032x = __webpack_require__(420);
	
	var _image_032x2 = _interopRequireDefault(_image_032x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trusonaAssets = {
	  heroLogo: _TrusonaFull2.default,
	  statsImage: {
	    src: _stats22x2.default,
	    srcSet: _stats22x2.default,
	    alt: 'Tursona and Marvel App'
	  },
	  stats: [{
	    id: 0,
	    stat: '5',
	    title: 'mins from paper to prototype',
	    copy: 'Taking rough sketches and turning them into “tappable” prototypes to test before investing time in producing final assets.'
	  }, {
	    id: 1,
	    stat: '2x',
	    title: 'faster meetings with Marvel prototypes',
	    copy: 'Communicating with prototypes means visualizing flows twice as fast.'
	  }, {
	    id: 2,
	    stat: '4',
	    title: 'continents collaborating on a single project',
	    copy: 'Marvel allows Trusona to collaborate across borders and time zones seamlessly.'
	  }],
	  doubleImages: {
	    zero: [{
	      src: _image_01_a2x2.default,
	      maxWidth: 556,
	      alt: 'Marvel on Mobile and Desktop'
	    }, {
	      src: _image_01_b2x2.default,
	      maxWidth: 556,
	      alt: 'Marvel facilitates Trusona’s workflow'
	    }],
	    first: [{
	      src: _image_02_a2x2.default,
	      maxWidth: 550,
	      alt: 'Trusona and Marvel Prototyping'
	    }, {
	      src: _image_02_b2x2.default,
	      maxWidth: 494,
	      alt: 'Trusona and Marvel Prototyping'
	    }]
	  },
	  singleImages: {
	    first: {
	      src: _image_032x2.default,
	      maxWidth: 1141,
	      alt: 'Trusona and Marvel Prototyping'
	    }
	  }
	};
	
	exports.default = trusonaAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _YieldrFull = __webpack_require__(195);
	
	var _YieldrFull2 = _interopRequireDefault(_YieldrFull);
	
	var _cover2x = __webpack_require__(422);
	
	var _cover2x2 = _interopRequireDefault(_cover2x);
	
	var _stats2x = __webpack_require__(433);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(424);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(425);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(426);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(427);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image03A2x = __webpack_require__(428);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(429);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _image052x = __webpack_require__(431);
	
	var _image052x2 = _interopRequireDefault(_image052x);
	
	var _image002x = __webpack_require__(423);
	
	var _image002x2 = _interopRequireDefault(_image002x);
	
	var _image042x = __webpack_require__(430);
	
	var _image042x2 = _interopRequireDefault(_image042x);
	
	var _quote2x = __webpack_require__(432);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var yieldrAssets = {
	  heroImage: {
	    alt: '',
	    maxWidth: 504,
	    src: _cover2x2.default
	  },
	  heroLogo: _YieldrFull2.default,
	  statsImage: {
	    alt: '',
	    maxWidth: 1290,
	    src: _stats2x2.default
	  },
	  stats: [{
	    id: 0,
	    stat: '30%',
	    title: 'Productivity increase',
	    copy: 'With Marvel’s Handoff tool, design and engineering worked together seamlessly'
	  }, {
	    id: 1,
	    stat: '4x',
	    title: 'Designs shipped',
	    copy: 'Marvel prototypes improved comms and reduced stakeholder back and forth'
	  }, {
	    id: 2,
	    stat: '200%',
	    title: 'Time reduction',
	    copy: 'With Marvel, decision making timeframes were faster and smoother'
	  }],
	  singleImages: {
	    first: {
	      src: _image002x2.default,
	      maxWidth: 1141,
	      alt: ''
	    },
	    second: {
	      src: _image052x2.default,
	      maxWidth: 1141,
	      alt: ''
	    }
	  },
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 494,
	      alt: ''
	    }],
	    second: [{
	      src: _image02A2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }],
	    third: [{
	      src: _quote2x2.default,
	      maxWidth: 556,
	      alt: ''
	    }, {
	      maxWidth: 490,
	      copy: '“It saves time in figuring out which prototype connects to which project. I don’t have to go back through Slack or email to find specs for a prototype or if it’s the latest one.”'
	    }],
	    fourth: [{
	      src: _image03A2x2.default,
	      maxWidth: 536,
	      alt: ''
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 550,
	      alt: ''
	    }],
	    singleImages: {
	      first: {
	        src: _image042x2.default,
	        maxWidth: 1141,
	        alt: ''
	      }
	    }
	  }
	};
	
	exports.default = yieldrAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ZincFull = __webpack_require__(196);
	
	var _ZincFull2 = _interopRequireDefault(_ZincFull);
	
	var _stats2x = __webpack_require__(445);
	
	var _stats2x2 = _interopRequireDefault(_stats2x);
	
	var _image01A2x = __webpack_require__(434);
	
	var _image01A2x2 = _interopRequireDefault(_image01A2x);
	
	var _image01B2x = __webpack_require__(435);
	
	var _image01B2x2 = _interopRequireDefault(_image01B2x);
	
	var _image02A2x = __webpack_require__(436);
	
	var _image02A2x2 = _interopRequireDefault(_image02A2x);
	
	var _image02B2x = __webpack_require__(437);
	
	var _image02B2x2 = _interopRequireDefault(_image02B2x);
	
	var _image03A2x = __webpack_require__(438);
	
	var _image03A2x2 = _interopRequireDefault(_image03A2x);
	
	var _image03B2x = __webpack_require__(439);
	
	var _image03B2x2 = _interopRequireDefault(_image03B2x);
	
	var _image05A2x = __webpack_require__(440);
	
	var _image05A2x2 = _interopRequireDefault(_image05A2x);
	
	var _image05B2x = __webpack_require__(441);
	
	var _image05B2x2 = _interopRequireDefault(_image05B2x);
	
	var _image06A2x = __webpack_require__(442);
	
	var _image06A2x2 = _interopRequireDefault(_image06A2x);
	
	var _image06B2x = __webpack_require__(443);
	
	var _image06B2x2 = _interopRequireDefault(_image06B2x);
	
	var _quote2x = __webpack_require__(444);
	
	var _quote2x2 = _interopRequireDefault(_quote2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var zincAssets = {
	  heroLogo: _ZincFull2.default,
	  statsImage: {
	    alt: 'Zinc and Marvel Prototyping',
	    maxWidth: 1290,
	    src: _stats2x2.default
	  },
	  stats: [{
	    id: 0,
	    stat: '55',
	    title: 'skilled individuals',
	    copy: 'From 800 applicants to their programme Zinc chooses a diversely skilled 55.'
	  }, {
	    id: 1,
	    stat: '2',
	    title: 'week bootcamp',
	    copy: 'Successful applicants are given an overview of the challenge they’re solving.'
	  }, {
	    id: 2,
	    stat: '6',
	    title: 'month programme',
	    copy: 'Helping them find business partners, gain access to funding, industry leaders and resources.'
	  }],
	
	  doubleImages: {
	    first: [{
	      src: _image01A2x2.default,
	      maxWidth: 550,
	      alt: 'Zinc Events'
	    }, {
	      src: _image01B2x2.default,
	      maxWidth: 550,
	      alt: 'Zinc Events'
	    }],
	    second: [{
	      src: _image02A2x2.default,
	      maxWidth: 556,
	      alt: 'Zinc and Amble'
	    }, {
	      src: _image02B2x2.default,
	      maxWidth: 556,
	      alt: 'Amble and Marvel'
	    }],
	    third: [{
	      src: _image03A2x2.default,
	      maxWidth: 536,
	      alt: 'Leika uses Marvel'
	    }, {
	      src: _image03B2x2.default,
	      maxWidth: 500,
	      alt: 'Leika and Marvel App'
	    }],
	    fourth: [{
	      src: _quote2x2.default,
	      maxWidth: 556,
	      alt: 'Squad uses Marvel App'
	    }, {
	      maxWidth: 490,
	      copy: '“It’s one thing saying we’re going to create something but once you start making it on Marvel it’s not just a prototype to show to investors anymore. It’s also a tool to get your head straight and make both small scale design decisions and the high level decisions.”'
	    }],
	    fifth: [{
	      src: _image05A2x2.default,
	      maxWidth: 550,
	      alt: 'Zone and Marvel App'
	    }, {
	      src: _image05B2x2.default,
	      maxWidth: 550,
	      alt: 'Zone prototypes with Marvel'
	    }],
	    sixth: [{
	      src: _image06A2x2.default,
	      maxWidth: 550,
	      alt: 'Zinc Events'
	    }, {
	      src: _image06B2x2.default,
	      maxWidth: 550,
	      alt: 'Zinc founder, Julia'
	    }]
	  }
	};
	
	exports.default = zincAssets;
	module.exports = exports['default'];

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BuzzfeedFull = __webpack_require__(183);
	
	var _BuzzfeedFull2 = _interopRequireDefault(_BuzzfeedFull);
	
	var _CabifyFull = __webpack_require__(185);
	
	var _CabifyFull2 = _interopRequireDefault(_CabifyFull);
	
	var _cookpadFull = __webpack_require__(197);
	
	var _cookpadFull2 = _interopRequireDefault(_cookpadFull);
	
	var _DeliverooFull = __webpack_require__(186);
	
	var _DeliverooFull2 = _interopRequireDefault(_DeliverooFull);
	
	var _DesignMuseumFull = __webpack_require__(187);
	
	var _DesignMuseumFull2 = _interopRequireDefault(_DesignMuseumFull);
	
	var _HudlFull = __webpack_require__(188);
	
	var _HudlFull2 = _interopRequireDefault(_HudlFull);
	
	var _LaboratoriaFull = __webpack_require__(189);
	
	var _LaboratoriaFull2 = _interopRequireDefault(_LaboratoriaFull);
	
	var _ModeFull = __webpack_require__(191);
	
	var _ModeFull2 = _interopRequireDefault(_ModeFull);
	
	var _MonzoFull = __webpack_require__(192);
	
	var _MonzoFull2 = _interopRequireDefault(_MonzoFull);
	
	var _NokiaFull = __webpack_require__(193);
	
	var _NokiaFull2 = _interopRequireDefault(_NokiaFull);
	
	var _YieldrFull = __webpack_require__(195);
	
	var _YieldrFull2 = _interopRequireDefault(_YieldrFull);
	
	var _TrusonaFull = __webpack_require__(194);
	
	var _TrusonaFull2 = _interopRequireDefault(_TrusonaFull);
	
	var _ZincFull = __webpack_require__(196);
	
	var _ZincFull2 = _interopRequireDefault(_ZincFull);
	
	var _buzzfeed2x = __webpack_require__(864);
	
	var _buzzfeed2x2 = _interopRequireDefault(_buzzfeed2x);
	
	var _cabify2x = __webpack_require__(865);
	
	var _cabify2x2 = _interopRequireDefault(_cabify2x);
	
	var _cookpad2x = __webpack_require__(866);
	
	var _cookpad2x2 = _interopRequireDefault(_cookpad2x);
	
	var _deliveroo2x = __webpack_require__(867);
	
	var _deliveroo2x2 = _interopRequireDefault(_deliveroo2x);
	
	var _designMuseum2x = __webpack_require__(868);
	
	var _designMuseum2x2 = _interopRequireDefault(_designMuseum2x);
	
	var _laboratoria2x = __webpack_require__(870);
	
	var _laboratoria2x2 = _interopRequireDefault(_laboratoria2x);
	
	var _hudl2x = __webpack_require__(869);
	
	var _hudl2x2 = _interopRequireDefault(_hudl2x);
	
	var _mode2x = __webpack_require__(871);
	
	var _mode2x2 = _interopRequireDefault(_mode2x);
	
	var _monzo2x = __webpack_require__(872);
	
	var _monzo2x2 = _interopRequireDefault(_monzo2x);
	
	var _nokiaHero = __webpack_require__(415);
	
	var _nokiaHero2 = _interopRequireDefault(_nokiaHero);
	
	var _yieldr2x = __webpack_require__(874);
	
	var _yieldr2x2 = _interopRequireDefault(_yieldr2x);
	
	var _trusona2x = __webpack_require__(873);
	
	var _trusona2x2 = _interopRequireDefault(_trusona2x);
	
	var _zinc2x = __webpack_require__(875);
	
	var _zinc2x2 = _interopRequireDefault(_zinc2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customerStoriesItems = [{
	  id: 0,
	  title: 'How Nokia uses Marvel to collaborate effectively across global teams',
	  logo: _react2.default.createElement(_NokiaFull2.default, { size: 90 }),
	  image: {
	    alt: 'How Nokia uses Marvel to collaborate effectively across global teams',
	    src: _nokiaHero2.default
	  },
	  url: '/case-studies/nokia'
	}, {
	  id: 1,
	  title: 'How Cabify closed design feedback loops to 15 minutes with Marvel',
	  logo: _react2.default.createElement(_CabifyFull2.default, { size: 90 }),
	  image: {
	    alt: 'How Cabify closed design feedback loops to 15 minutes with Marvel',
	    src: _cabify2x2.default
	  },
	  url: '/case-studies/cabify'
	}, {
	  id: 2,
	  title: 'How Marvel keeps Monzo shipping every two weeks',
	  logo: _react2.default.createElement(_MonzoFull2.default, { size: 90 }),
	  image: {
	    alt: 'How Marvel keeps Monzo shipping every two weeks',
	    maxWidth: 362,
	    src: _monzo2x2.default
	  },
	  url: '/case-studies/monzo'
	}, {
	  id: 3,
	  title: "How Buzzfeed's design team created a single source of truth with Marvel",
	  logo: _react2.default.createElement(_BuzzfeedFull2.default, { size: 90 }),
	  image: {
	    alt: "How Buzzfeed's design team created a single source of truth with Marvel",
	    src: _buzzfeed2x2.default
	  },
	  url: '/case-studies/buzzfeed'
	}, {
	  id: 4,
	  title: 'How Hudl drive great UX through daily user testing with Marvel',
	  logo: _react2.default.createElement(_HudlFull2.default, { size: 80 }),
	  image: {
	    alt: 'How Hudl drive great UX through daily user testing with Marvel',
	    src: _hudl2x2.default
	  },
	  url: '/case-studies/hudl'
	}, {
	  id: 5,
	  title: 'How Yieldr increased productivity by 30% using Marvel’s Handoff tool',
	  logo: _react2.default.createElement(_YieldrFull2.default, { size: 70 }),
	  image: {
	    alt: 'How Yieldr increased productivity by 30% using Marvel’s Handoff tool',
	    maxWidth: 362,
	    src: _yieldr2x2.default
	  },
	  url: '/case-studies/yieldr'
	}, {
	  id: 6,
	  title: 'How Trusona empowered their workflow and Sales Team with Marvel prototypes',
	  logo: _react2.default.createElement(_TrusonaFull2.default, null),
	  image: {
	    alt: 'How Trusona empowered their workflow and Sales Team with Marvel prototypes',
	    maxWidth: 362,
	    src: _trusona2x2.default
	  },
	  url: '/case-studies/trusona'
	}, {
	  id: 7,
	  title: 'Why Zinc introduces Marvel to their incubator startups',
	  logo: _react2.default.createElement(_ZincFull2.default, null),
	  image: {
	    alt: 'Why Zinc introduces Marvel to their incubator startups',
	    maxWidth: 362,
	    src: _zinc2x2.default
	  },
	  url: '/case-studies/zinc'
	}, {
	  id: 8,
	  title: 'How Cookpad uses Marvel to tackle the big risks in product design, early on.',
	  logo: _react2.default.createElement(_cookpadFull2.default, { width: 120, height: 35 }),
	  image: {
	    alt: 'How Cookpad uses Marvel to tackle the big risks in product design, early on.',
	    maxWidth: 362,
	    src: _cookpad2x2.default
	  },
	  url: '/case-studies/cookpad'
	}, {
	  id: 9,
	  title: 'How the Design Museum uses Marvel to make their workshops engaging, interactive and fun',
	  logo: _react2.default.createElement(_DesignMuseumFull2.default, { width: 65, height: 50 }),
	  image: {
	    alt: 'How the Design Museum uses Marvel to make their workshops engaging, interactive and fun',
	    maxWidth: 362,
	    src: _designMuseum2x2.default
	  },
	  url: '/case-studies/designmuseum'
	}, {
	  id: 10,
	  title: 'How Laboratoria’s students foster learning in design with Marvel',
	  logo: _react2.default.createElement(_LaboratoriaFull2.default, { size: 130 }),
	  image: {
	    alt: 'How Laboratoria’s students foster design learning in design with Marvel',
	    maxWidth: 362,
	    src: _laboratoria2x2.default
	  },
	  url: '/case-studies/laboratoria'
	}, {
	  id: 11,
	  title: 'How Marvel Handoff transformed Mode’s design to development communication',
	  logo: _react2.default.createElement(_ModeFull2.default, null),
	  image: {
	    alt: 'How Marvel Handoff transformed Mode’s design to development communication',
	    maxWidth: 400,
	    src: _mode2x2.default
	  },
	  url: '/case-studies/mode'
	}, {
	  id: 12,
	  title: 'How Deliveroo speed up iteration and drive great design with Marvel',
	  logo: _react2.default.createElement(_DeliverooFull2.default, { size: 100 }),
	  image: {
	    alt: 'How Deliveroo speed up iteration and drive great design with Marvel',
	    src: _deliveroo2x2.default
	  },
	  url: '/case-studies/deliveroo'
	}];
	
	exports.default = customerStoriesItems;
	module.exports = exports['default'];

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cover@2x-5739a27022a0e97ae58ab70974d3e01f.jpg";

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-2aa138035be714be0a0460d67eebe746.jpg";

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-61c851e8c7bd5e358840c6e63db97997.jpg";

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-49d46fbc13a9e044d670b63f1d49b084.jpg";

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-2ecdd75e6c0d3edf925ac4e3ccd13d82.jpg";

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03@2x-a368194acf6d6daeb010510e0f9e4f16.jpg";

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-15f8b0eb1f5b62d1b98f74660b1c1dff.jpg";

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-aecaf5a98a61460c23584ebf810c29f3.jpg";

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-00-a@2x-7e0e3bb31ca6932c5b9d40fd3729ce87.jpg";

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-00-b@2x-97b9a735c51d1e5da87012a7686098c6.jpg";

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-393d0ae0cfb291a0bc3c31737f493bd0.jpg";

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-c4d8ea9a92af38e22acf62c75901b235.jpg";

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-bf02ff6ea5b8a15ba0632becc5b02251.jpg";

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-c@2x-eb15f7d387c35118e90bc2422470e46c.jpg";

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03@2x-f12a33a9f4698b0fbf7de797815d42e5.jpg";

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-ae65b8497e75574619f1d6eca353a849.jpg";

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats2@2x-9fd26821fdf74d962ce819615d35cd3b.jpg";

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-9b2d232329a1c795838bc336e0311f65.jpg";

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-72f1c7f9fec01d8eb47b8598aafc3d34.jpg";

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-0c480e0c6ddb36b027c0c788b1de56c4.jpg";

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-3845d2b446ebb7420332e5c87f989d96.jpg";

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-8e82851713236dbee305bd44fff0ca0f.jpg";

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-7eb8094798e2641bcfeb0bb6c4b03315.png";

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-a@2x-fefbab30c118cb201ac3b3d81090cf07.jpg";

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-b-alternative@2x-1eb9fac4f6f39f8eee04dd52ef663978.jpg";

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-947b11410d2f7cf4180f0891142d1b1e.jpg";

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-4dfe18b20595cc00d181dacf2a48f913.jpg";

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cover@2x-01da721ad0cf618f403934b7982d7aeb.jpg";

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-747cda8d641bc6ce1a52c82a5045fc71.jpg";

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-09b2b40716cd00b38368a9ef65e3f0a5.jpg";

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-b25c9632e92a061538f336647b696ec3.jpg";

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-5fa0f2e3b6aac9e6f8f8facd04ec6052.jpg";

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-602acd346151dc614837cb959e7af272.jpg";

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-fde5a286d1172cd55b02cbb70a54bc74.jpg";

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-a@2x-86c9850686a64f272ca3016cb5afd28e.jpg";

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-b@2x-3afc6cb401305276c662056bcfe74cf5.jpg";

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-quote@2x-9bc5f1b136c126251f646562a0be1c1a.jpg";

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-31a8ccc8eb9971a69e18c894b0007a73.jpg";

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-91e0908320d5bf6010fde73e8da4cf7c.jpg";

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-f8ad94cc009e90e79b2612fbd66d34f8.jpg";

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-f52d03a708c39df5a5179d117a828227.jpg";

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-c5c0488cb68e423ecd5dad5449e9127d.jpg";

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-214a5cf6de6f727574638d155464b9c7.jpg";

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-972987e12b5576244b7ab50e14f419ec.jpg";

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-a@2x-8a0e2b8fe0334fd910eb59276ab8f900.jpg";

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-b@2x-ec035cb3fd235e0952ed63197f9a6abb.jpg";

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04@2x-396f7dc292945410119c0e3c52840466.jpg";

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05-a@2x-92af9cf58bf9a006f0b9b2920e9e27c3.jpg";

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05-b@2x-37bea213019b385424282c00226ea8c5.jpg";

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-c87a87bfed76da83acea4e2b0ec56a1c.jpg";

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-00-a@2x-7a63da9770dba1393010fa038a87e4c7.jpg";

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-00-b@2x-4185296ef706b76c88e328ce063fb0ee.jpg";

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-45b0d4f6d626b978ce4caf645b682064.jpg";

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-dbfb10cb9e4b3f7523fcbfbc81af4d4f.jpg";

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02@2x-222831c8b795abc5695591f0e64d703f.jpg";

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-9c7a2e76a757bb8a69d8076e90af9055.jpg";

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-dcf08317fbcfaf1da4d973c1b2e0dfdb.jpg";

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-d05e03d36cacaa83cadf86b56d248a4f.jpg";

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-2f0b9ed5dee042f85851697f1e388870.jpg";

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-d6d5198162b1422f5e614d1a53b596ea.jpg";

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-01f94f4eb72605b62a128ab95b2fb16e.jpg";

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-838ee5a750d471d777e0a0f8b40f22ca.jpg";

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-093fcfb89ddc8f89c6f9763f8c6c05a8.jpg";

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-5cc8dcbeb413b70bc02e37149fab9bf3.jpg";

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-ab94c670d1a776d348b88f5dd1bbbaa5.jpg";

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03@2x-092d06a06361a3c1dc535ae212a2a742.jpg";

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-a@2x-6fe9d505d2220dae37284374243ff1a4.jpg";

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-b@2x-c58dc78b81dfd1807bfc07fcee802180.jpg";

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05@2x-76d1daf2abb1c6ceb3998c583aa14228.jpg";

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-2284aed33b509b5d3c0c4525f3486c3c.jpg";

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-0fb5bbbcac40cb8a474be0f56dbecad1.jpg";

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-429315b722e605967e2f8364436fd7d6.jpg";

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03@2x-f8f6d3970c7900bf0f5aad5cb0bceae2.jpg";

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-a@2x-79ad2e4c85bfc5c7eb7eac201f37f563.jpg";

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04-b@2x-8e4a4203b7fa8a1097f7b480d8d17566.jpg";

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05-a@2x-31b0beec90f522c1edeffe8c5091755b.jpg";

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05-b@2x-8d7fe22e620bdd644efbb3a3c4fbc2c5.jpg";

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-b2d355a1502bcc1efc3649b5813fc068.jpg";

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-d77b64a167a44d6de574c0e79a31ad1e.jpg";

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image01a@2x-562f2a400cebde0a4bb68f16bb8ab892.jpg";

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image01b@2x-f9d473f767e966971171a92b9dddbd9a.jpg";

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image02a@2x-b7e3e1f90eed3e04992cce6e69870616.jpg";

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image02b@2x-f4b425bd2b2132c87934b850be5bb407.jpg";

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image03a@2x-05a5d3dcd85476c0f4f026bec3fde6b0.jpg";

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image04a@2x-105f5b27f84d9629cb4226ccfe8eb5a7.jpg";

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image05a@2x-cc08a6e2fa8c808bc6ec60526150c8ef.jpg";

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image05b@2x-254180957d4f59c4b2b3efd3f681a3ea.jpg";

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/monzo-stats@2x-cd62492053c0314d28c1bd082fac935e.jpg";

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nokia-1-d85ff8ce79b6c0d888790038784aea3a.jpg";

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nokia-2-99f43e12145e7250f1105815c4bb6d67.jpg";

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image_01_a@2x-07341d92c8967281b2dd7790afdd2203.jpg";

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image_01_b@2x-c83444f3d890bcd3854bc202cdc6229d.jpg";

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image_02_a@2x-719c43a6c7366c153edd5bf469c3537d.jpg";

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image_02_b@2x-a6044e39e093336137fe5e5cfbfc10eb.png";

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image_03@2x-4ed7ea536b1dcb8ed3833fe655544f88.jpg";

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats2@2x-ed311a628002f546494832053a7420a9.jpg";

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cover@2x-f355119c88b4a0d8edad0cca4de99779.jpg";

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-00@2x-3692cfef2020f4587d1d45e0f8f80811.jpg";

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-787f1bc2674c72bf879db1298beb9b82.jpg";

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-44722bff15fd3dfbc323847452828328.jpg";

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-f4472de86b006d313e998d2b08fe8d09.jpg";

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-d995c482808ae5a9f217ce1d487274d0.jpg";

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-588332452ef8431b24e42875ac51291b.jpg";

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-fa07a57d344bdac4cacf09a29efd9330.jpg";

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-04@2x-fb789c422bf8599690e3f133e8550991.jpg";

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05@2x-fb789c422bf8599690e3f133e8550991.jpg";

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-39d578091348dbe7f91ddb17ff4bede4.jpg";

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-a690649b8636ea59d4a7f18221957b67.jpg";

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-a@2x-3ff2a502ac5efa67e7cd320cbfff3105.jpg";

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-01-b@2x-645b852e69e1a411ce94f47f38977e86.jpg";

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-a@2x-d8dd3235c373e1fc85507568650ab3fe.jpg";

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-02-b@2x-a7ecef90243402910f6001e3f833679e.jpg";

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-a@2x-00825eaca3b633d0d10c472ac2fe95a6.jpg";

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-03-b@2x-8900cdede538b1f067bb46bbe64c0c93.png";

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05-a@2x-17fad6084e8a6c390f809b9076f64827.jpg";

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-05-b@2x-b274ee2ad5eb2105aedeb17831583b63.jpg";

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-06-a@2x-c0cd541a79c0e98a08c2391b31a1130d.jpg";

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image-06-b@2x-a5e7e3274e16a7d53022e64c1659648a.png";

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/quote@2x-69d790331aad119909460889318919ca.jpg";

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/stats@2x-ba8f5ec53dfbe71cf415b69a4f9024cf.jpg";

/***/ }),

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/buzzfeed@2x-f3fe92c65444fdd24722645ecfe2e4f7.jpg";

/***/ }),

/***/ 865:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cabify@2x-41442eacccf4f94dcff4b536bdc56e99.jpg";

/***/ }),

/***/ 866:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cookpad@2x-f3293bd476116497a90399a136bb74c8.jpg";

/***/ }),

/***/ 867:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/deliveroo@2x-21cd0f4b870cc38b2f5b9a413beccbac.jpg";

/***/ }),

/***/ 868:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/design-museum@2x-e53ef5703c8c78a76735c259ea7e4b17.jpg";

/***/ }),

/***/ 869:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hudl@2x-1488e5bddc7e57eb0685f01294f587b5.jpg";

/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/laboratoria@2x-1c8ef56fd28b6436fd783372bd122fe1.png";

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mode@2x-e8042bf00e80e79002a4e42ffd6d35f3.jpg";

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/monzo@2x-50aff407137e0baf2d62364a4b47e102.jpg";

/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/trusona@2x-f22f6ec899e120169cf29370801faaa3.jpg";

/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/yieldr@2x-3692cfef2020f4587d1d45e0f8f80811.jpg";

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/zinc@2x-64d071bf19b4837936d3eda96ef1760e.jpg";

/***/ }),

/***/ 1320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.caseStudiesQuery = undefined;
	exports.default = CaseStudiesDetailTemplate;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rehypeReact = __webpack_require__(310);
	
	var _rehypeReact2 = _interopRequireDefault(_rehypeReact);
	
	var _shuffle = __webpack_require__(298);
	
	var _shuffle2 = _interopRequireDefault(_shuffle);
	
	var _Hero = __webpack_require__(1165);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Copy = __webpack_require__(1163);
	
	var _Copy2 = _interopRequireDefault(_Copy);
	
	var _DoubleImage = __webpack_require__(1164);
	
	var _DoubleImage2 = _interopRequireDefault(_DoubleImage);
	
	var _ReadMore = __webpack_require__(1169);
	
	var _ReadMore2 = _interopRequireDefault(_ReadMore);
	
	var _Quote = __webpack_require__(1168);
	
	var _Quote2 = _interopRequireDefault(_Quote);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _ImageQuote = __webpack_require__(1167);
	
	var _ImageQuote2 = _interopRequireDefault(_ImageQuote);
	
	var _ImageStats = __webpack_require__(198);
	
	var _ImageStats2 = _interopRequireDefault(_ImageStats);
	
	var _Social = __webpack_require__(1170);
	
	var _Social2 = _interopRequireDefault(_Social);
	
	var _ImageBlock = __webpack_require__(1166);
	
	var _ImageBlock2 = _interopRequireDefault(_ImageBlock);
	
	var _CtaStories = __webpack_require__(565);
	
	var _CtaStories2 = _interopRequireDefault(_CtaStories);
	
	var _SmartLink = __webpack_require__(36);
	
	var _SmartLink2 = _interopRequireDefault(_SmartLink);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _customerStoriesItems = __webpack_require__(612);
	
	var _customerStoriesItems2 = _interopRequireDefault(_customerStoriesItems);
	
	var _customPropTypesCheck = __webpack_require__(20);
	
	var _customPropTypesCheck2 = _interopRequireDefault(_customPropTypesCheck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	CaseStudiesDetailTemplate.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.shape({
	      htmlAst: _propTypes2.default.object,
	      frontmatter: _propTypes2.default.shape({
	        page: _customPropTypesCheck2.default,
	        summary: _customPropTypesCheck2.default
	      })
	    })
	  })
	};
	
	function CaseStudiesDetailTemplate(_ref) {
	  var data = _ref.data;
	
	  if (!data || !data.markdownRemark) return null;
	
	  var markdownRemark = data.markdownRemark;
	  var frontmatter = markdownRemark.frontmatter,
	      htmlAst = markdownRemark.htmlAst;
	  var page = frontmatter.page;
	
	
	  var componentsMap = {
	    'copy-block': _Copy2.default,
	    'double-image-block': _DoubleImage2.default,
	    'hero-block': _Hero2.default,
	    'image-quote-block': _ImageQuote2.default,
	    'quote-block': _Quote2.default,
	    'stats-block': _ImageStats2.default,
	    'image-block': _ImageBlock2.default,
	    'smart-link': _SmartLink2.default
	  };
	
	  var renderAst = new _rehypeReact2.default({
	    createElement: _react2.default.createElement,
	    components: componentsMap
	  }).Compiler;
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: _metadata2.default['case-studies'][page].title,
	      meta: [{
	        name: 'description',
	        content: _metadata2.default['case-studies'][page].description
	      }, { name: 'keywords', content: _metadata2.default['case-studies'][page].keywords }],
	      header: { isLight: false },
	      footer: true
	    },
	    renderAst(htmlAst),
	    _react2.default.createElement(_Social2.default, null),
	    _react2.default.createElement(_ReadMore2.default, { articles: (0, _shuffle2.default)(_customerStoriesItems2.default) }),
	    _react2.default.createElement(_CtaStories2.default, null)
	  );
	}
	
	var caseStudiesQuery = exports.caseStudiesQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-case-studies-js-8e58dac57f4261986511.js